
(() => {
    try {
        if(!self.__SRX_MODULES__) {
            const store = new class extends Array {
                dump() { console.table(this) };
            };
            Object.defineProperty(self, "__SRX_MODULES__", {
                get() { return store; },
                set() {},
            });
            self.__SRX_DUMP__ = () => self.__SRX_MODULES__.dump();
        };
        self.__SRX_MODULES__.push({"name":"@sarex-frontend","version":"5.3.0","buildAt":"2026-11-03T17:38:18.305Z","tag":"--","hash":"b4e61425","branch":"stage","chunk":"-"});
    } catch(e) { console.warn("Build info inject error", e); };
})();
;
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 50215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90660);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59676);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32919);
/* harmony import */ var _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__);
// Imports



var ___CSS_LOADER_URL_IMPORT_0___ = new URL(/* asset import */ __webpack_require__(92556), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL(/* asset import */ __webpack_require__(82938), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL(/* asset import */ __webpack_require__(57421), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL(/* asset import */ __webpack_require__(81365), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL(/* asset import */ __webpack_require__(21036), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL(/* asset import */ __webpack_require__(97274), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL(/* asset import */ __webpack_require__(31725), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL(/* asset import */ __webpack_require__(80533), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL(/* asset import */ __webpack_require__(63498), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL(/* asset import */ __webpack_require__(21060), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL(/* asset import */ __webpack_require__(96140), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL(/* asset import */ __webpack_require__(56107), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL(/* asset import */ __webpack_require__(49107), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL(/* asset import */ __webpack_require__(37939), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL(/* asset import */ __webpack_require__(3284), __webpack_require__.b);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL(/* asset import */ __webpack_require__(63340), __webpack_require__.b);
var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
var ___CSS_LOADER_URL_REPLACEMENT_0___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = _node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root .tiptap{overflow-wrap:break-word;text-size-adjust:none}:root{text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;--tt-gray-light-a-50: rgba(56, 56, 56, 0.04);--tt-gray-light-a-100: rgba(15, 22, 36, 0.05);--tt-gray-light-a-200: rgba(37, 39, 45, 0.1);--tt-gray-light-a-300: rgba(47, 50, 55, 0.2);--tt-gray-light-a-400: rgba(40, 44, 51, 0.42);--tt-gray-light-a-500: rgba(52, 55, 60, 0.64);--tt-gray-light-a-600: rgba(36, 39, 46, 0.78);--tt-gray-light-a-700: rgba(35, 37, 42, 0.87);--tt-gray-light-a-800: rgba(30, 32, 36, 0.95);--tt-gray-light-a-900: rgba(29, 30, 32, 0.98);--tt-gray-light-50: rgba(250, 250, 250, 1);--tt-gray-light-100: rgba(244, 244, 245, 1);--tt-gray-light-200: rgba(234, 234, 235, 1);--tt-gray-light-300: rgba(213, 214, 215, 1);--tt-gray-light-400: rgba(166, 167, 171, 1);--tt-gray-light-500: rgba(125, 127, 130, 1);--tt-gray-light-600: rgba(83, 86, 90, 1);--tt-gray-light-700: rgba(64, 65, 69, 1);--tt-gray-light-800: rgba(44, 45, 48, 1);--tt-gray-light-900: rgba(34, 35, 37, 1);--tt-gray-dark-a-50: rgba(232, 232, 253, 0.05);--tt-gray-dark-a-100: rgba(231, 231, 243, 0.07);--tt-gray-dark-a-200: rgba(238, 238, 246, 0.11);--tt-gray-dark-a-300: rgba(239, 239, 245, 0.22);--tt-gray-dark-a-400: rgba(244, 244, 255, 0.37);--tt-gray-dark-a-500: rgba(236, 238, 253, 0.5);--tt-gray-dark-a-600: rgba(247, 247, 253, 0.64);--tt-gray-dark-a-700: rgba(251, 251, 254, 0.75);--tt-gray-dark-a-800: rgba(253, 253, 253, 0.88);--tt-gray-dark-a-900: rgba(255, 255, 255, 0.96);--tt-gray-dark-50: rgba(25, 25, 26, 1);--tt-gray-dark-100: rgba(32, 32, 34, 1);--tt-gray-dark-200: rgba(45, 45, 47, 1);--tt-gray-dark-300: rgba(70, 70, 73, 1);--tt-gray-dark-400: rgba(99, 99, 105, 1);--tt-gray-dark-500: rgba(124, 124, 131, 1);--tt-gray-dark-600: rgba(163, 163, 168, 1);--tt-gray-dark-700: rgba(192, 192, 195, 1);--tt-gray-dark-800: rgba(224, 224, 225, 1);--tt-gray-dark-900: rgba(245, 245, 245, 1);--tt-brand-color-50: rgba(239, 238, 255, 1);--tt-brand-color-100: rgba(222, 219, 255, 1);--tt-brand-color-200: rgba(195, 189, 255, 1);--tt-brand-color-300: rgba(157, 138, 255, 1);--tt-brand-color-400: rgba(122, 82, 255, 1);--tt-brand-color-500: rgba(98, 41, 255, 1);--tt-brand-color-600: rgba(84, 0, 229, 1);--tt-brand-color-700: rgba(75, 0, 204, 1);--tt-brand-color-800: rgba(56, 0, 153, 1);--tt-brand-color-900: rgba(43, 25, 102, 1);--tt-brand-color-950: hsla(257, 100%, 9%, 1);--tt-color-green-inc-5: hsla(129, 100%, 97%, 1);--tt-color-green-inc-4: hsla(129, 100%, 92%, 1);--tt-color-green-inc-3: hsla(131, 100%, 86%, 1);--tt-color-green-inc-2: hsla(133, 98%, 78%, 1);--tt-color-green-inc-1: hsla(137, 99%, 70%, 1);--tt-color-green-base: hsla(147, 99%, 50%, 1);--tt-color-green-dec-1: hsla(147, 97%, 41%, 1);--tt-color-green-dec-2: hsla(146, 98%, 32%, 1);--tt-color-green-dec-3: hsla(146, 100%, 24%, 1);--tt-color-green-dec-4: hsla(144, 100%, 16%, 1);--tt-color-green-dec-5: hsla(140, 100%, 9%, 1);--tt-color-yellow-inc-5: hsla(50, 100%, 97%, 1);--tt-color-yellow-inc-4: hsla(50, 100%, 91%, 1);--tt-color-yellow-inc-3: hsla(50, 100%, 84%, 1);--tt-color-yellow-inc-2: hsla(50, 100%, 77%, 1);--tt-color-yellow-inc-1: hsla(50, 100%, 68%, 1);--tt-color-yellow-base: hsla(52, 100%, 50%, 1);--tt-color-yellow-dec-1: hsla(52, 100%, 41%, 1);--tt-color-yellow-dec-2: hsla(52, 100%, 32%, 1);--tt-color-yellow-dec-3: hsla(52, 100%, 24%, 1);--tt-color-yellow-dec-4: hsla(51, 100%, 16%, 1);--tt-color-yellow-dec-5: hsla(50, 100%, 9%, 1);--tt-color-red-inc-5: hsla(11, 100%, 96%, 1);--tt-color-red-inc-4: hsla(11, 100%, 88%, 1);--tt-color-red-inc-3: hsla(10, 100%, 80%, 1);--tt-color-red-inc-2: hsla(9, 100%, 73%, 1);--tt-color-red-inc-1: hsla(7, 100%, 64%, 1);--tt-color-red-base: hsla(7, 100%, 54%, 1);--tt-color-red-dec-1: hsla(7, 100%, 41%, 1);--tt-color-red-dec-2: hsla(5, 100%, 32%, 1);--tt-color-red-dec-3: hsla(4, 100%, 24%, 1);--tt-color-red-dec-4: hsla(3, 100%, 16%, 1);--tt-color-red-dec-5: hsla(1, 100%, 9%, 1);--white: rgba(255, 255, 255, 1);--black: rgba(14, 14, 17, 1);--transparent: rgba(255, 255, 255, 0);--tt-shadow-elevated-md: 0px 16px 48px 0px rgba(17, 24, 39, 0.04), 0px 12px 24px 0px rgba(17, 24, 39, 0.04), 0px 6px 8px 0px rgba(17, 24, 39, 0.02), 0px 2px 3px 0px rgba(17, 24, 39, 0.02);--tt-radius-xxs: 0.125rem;--tt-radius-xs: 0.25rem;--tt-radius-sm: 0.375rem;--tt-radius-md: 0.5rem;--tt-radius-lg: 0.75rem;--tt-radius-xl: 1rem;--tt-transition-duration-short: 0.1s;--tt-transition-duration-default: 0.2s;--tt-transition-duration-long: 0.64s;--tt-transition-easing-default: cubic-bezier(0.46, 0.03, 0.52, 0.96);--tt-transition-easing-cubic: cubic-bezier(0.65, 0.05, 0.36, 1);--tt-transition-easing-quart: cubic-bezier(0.77, 0, 0.18, 1);--tt-transition-easing-circ: cubic-bezier(0.79, 0.14, 0.15, 0.86);--tt-transition-easing-back: cubic-bezier(0.68, -0.55, 0.27, 1.55);--tt-accent-contrast: 8%;--tt-destructive-contrast: 8%;--tt-foreground-contrast: 8%}:root .tiptap,:root .tiptap *,:root .tiptap ::before,:root .tiptap ::after{box-sizing:border-box;transition:none var(--tt-transition-duration-default) var(--tt-transition-easing-default)}:root{--tt-bg-color: var(--white);--tt-border-color: var(--tt-gray-light-a-200);--tt-border-color-tint: var(--tt-gray-light-a-100);--tt-sidebar-bg-color: var(--tt-gray-light-100);--tt-scrollbar-color: var(--tt-gray-light-a-200);--tt-cursor-color: var(--tt-brand-color-500);--tt-selection-color: rgba(157, 138, 255, 0.2);--tt-card-bg-color: var(--white);--tt-card-border-color: var(--tt-gray-light-a-100)}.dark{--tt-bg-color: var(--black);--tt-border-color: var(--tt-gray-dark-a-200);--tt-border-color-tint: var(--tt-gray-dark-a-100);--tt-sidebar-bg-color: var(--tt-gray-dark-100);--tt-scrollbar-color: var(--tt-gray-dark-a-200);--tt-cursor-color: var(--tt-brand-color-400);--tt-selection-color: rgba(122, 82, 255, 0.2);--tt-card-bg-color: var(--tt-gray-dark-50);--tt-card-border-color: var(--tt-gray-dark-a-50);--tt-shadow-elevated-md: 0px 16px 48px 0px rgba(0, 0, 0, 0.5), 0px 12px 24px 0px rgba(0, 0, 0, 0.24), 0px 6px 8px 0px rgba(0, 0, 0, 0.22), 0px 2px 3px 0px rgba(0, 0, 0, 0.12)}:root{--tt-color-text-gray: hsl(45, 2%, 46%);--tt-color-text-brown: hsl(19, 31%, 47%);--tt-color-text-orange: hsl(30, 89%, 45%);--tt-color-text-yellow: hsl(38, 62%, 49%);--tt-color-text-green: hsl(148, 32%, 39%);--tt-color-text-blue: hsl(202, 54%, 43%);--tt-color-text-purple: hsl(274, 32%, 54%);--tt-color-text-pink: hsl(328, 49%, 53%);--tt-color-text-red: hsl(2, 62%, 55%);--tt-color-text-gray-contrast: hsla(39, 26%, 26%, 0.15);--tt-color-text-brown-contrast: hsla(18, 43%, 69%, 0.35);--tt-color-text-orange-contrast: hsla(24, 73%, 55%, 0.27);--tt-color-text-yellow-contrast: hsla(44, 82%, 59%, 0.39);--tt-color-text-green-contrast: hsla(126, 29%, 60%, 0.27);--tt-color-text-blue-contrast: hsla(202, 54%, 59%, 0.27);--tt-color-text-purple-contrast: hsla(274, 37%, 64%, 0.27);--tt-color-text-pink-contrast: hsla(331, 60%, 71%, 0.27);--tt-color-text-red-contrast: hsla(8, 79%, 79%, 0.4)}.dark{--tt-color-text-gray: hsl(0, 0%, 61%);--tt-color-text-brown: hsl(18, 35%, 58%);--tt-color-text-orange: hsl(25, 53%, 53%);--tt-color-text-yellow: hsl(36, 54%, 55%);--tt-color-text-green: hsl(145, 32%, 47%);--tt-color-text-blue: hsl(202, 64%, 52%);--tt-color-text-purple: hsl(270, 55%, 62%);--tt-color-text-pink: hsl(329, 57%, 58%);--tt-color-text-red: hsl(1, 69%, 60%);--tt-color-text-gray-contrast: hsla(0, 0%, 100%, 0.09);--tt-color-text-brown-contrast: hsla(17, 45%, 50%, 0.25);--tt-color-text-orange-contrast: hsla(27, 82%, 53%, 0.2);--tt-color-text-yellow-contrast: hsla(35, 49%, 47%, 0.2);--tt-color-text-green-contrast: hsla(151, 55%, 39%, 0.2);--tt-color-text-blue-contrast: hsla(202, 54%, 43%, 0.2);--tt-color-text-purple-contrast: hsla(271, 56%, 60%, 0.18);--tt-color-text-pink-contrast: hsla(331, 67%, 58%, 0.22);--tt-color-text-red-contrast: hsla(0, 67%, 60%, 0.25)}:root{--tt-color-highlight-yellow: #fef9c3;--tt-color-highlight-green: #dcfce7;--tt-color-highlight-blue: #e0f2fe;--tt-color-highlight-purple: #f3e8ff;--tt-color-highlight-red: #ffe4e6;--tt-color-highlight-gray: rgb(248, 248, 247);--tt-color-highlight-brown: rgb(244, 238, 238);--tt-color-highlight-orange: rgb(251, 236, 221);--tt-color-highlight-pink: rgb(252, 241, 246);--tt-color-highlight-yellow-contrast: #fbe604;--tt-color-highlight-green-contrast: #c7fad8;--tt-color-highlight-blue-contrast: #ceeafd;--tt-color-highlight-purple-contrast: #e4ccff;--tt-color-highlight-red-contrast: #ffccd0;--tt-color-highlight-gray-contrast: rgba(84, 72, 49, 0.15);--tt-color-highlight-brown-contrast: rgba(210, 162, 141, 0.35);--tt-color-highlight-orange-contrast: rgba(224, 124, 57, 0.27);--tt-color-highlight-pink-contrast: rgba(225, 136, 179, 0.27)}.dark{--tt-color-highlight-yellow: #6b6524;--tt-color-highlight-green: #509568;--tt-color-highlight-blue: #6e92aa;--tt-color-highlight-purple: #583e74;--tt-color-highlight-red: #743e42;--tt-color-highlight-gray: rgb(47, 47, 47);--tt-color-highlight-brown: rgb(74, 50, 40);--tt-color-highlight-orange: rgb(92, 59, 35);--tt-color-highlight-pink: rgb(78, 44, 60);--tt-color-highlight-yellow-contrast: #58531e;--tt-color-highlight-green-contrast: #47855d;--tt-color-highlight-blue-contrast: #5e86a1;--tt-color-highlight-purple-contrast: #4c3564;--tt-color-highlight-red-contrast: #643539;--tt-color-highlight-gray-contrast: rgba(255, 255, 255, 0.094);--tt-color-highlight-brown-contrast: rgba(184, 101, 69, 0.25);--tt-color-highlight-orange-contrast: rgba(233, 126, 37, 0.2);--tt-color-highlight-pink-contrast: rgba(220, 76, 145, 0.22)}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{from{opacity:1}to{opacity:0}}@keyframes zoomIn{from{transform:scale(0.95)}to{transform:scale(1)}}@keyframes zoomOut{from{transform:scale(1)}to{transform:scale(0.95)}}@keyframes zoom{0%{opacity:0;transform:scale(0.95)}100%{opacity:1;transform:scale(1)}}@keyframes slideFromTop{from{transform:translateY(-0.5rem)}to{transform:translateY(0)}}@keyframes slideFromRight{from{transform:translateX(0.5rem)}to{transform:translateX(0)}}@keyframes slideFromLeft{from{transform:translateX(-0.5rem)}to{transform:translateX(0)}}@keyframes slideFromBottom{from{transform:translateY(0.5rem)}to{transform:translateY(0)}}@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@font-face{font-family:\"TTLakes\";src:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") format(\"woff2\"),url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:\"TTLakes\";src:url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ") format(\"woff2\"),url(" + ___CSS_LOADER_URL_REPLACEMENT_3___ + ") format(\"woff\");font-weight:500;font-style:normal}@font-face{font-family:\"IBMPlexSans\";src:url(" + ___CSS_LOADER_URL_REPLACEMENT_4___ + ") format(\"woff2\"),url(" + ___CSS_LOADER_URL_REPLACEMENT_5___ + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:\"IBMPlexSans\";src:url(" + ___CSS_LOADER_URL_REPLACEMENT_6___ + ") format(\"woff2\"),url(" + ___CSS_LOADER_URL_REPLACEMENT_7___ + ") format(\"woff\");font-weight:500;font-style:normal}@font-face{font-family:\"isocpeur\";src:url(" + ___CSS_LOADER_URL_REPLACEMENT_8___ + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:\"RostelecomBasis\";src:url(" + ___CSS_LOADER_URL_REPLACEMENT_9___ + ") format(\"opentype\");font-weight:400;font-style:normal}@font-face{font-family:\"RostelecomBasis\";src:url(" + ___CSS_LOADER_URL_REPLACEMENT_10___ + ") format(\"opentype\");font-weight:300;font-style:normal}@font-face{font-family:\"RostelecomBasis\";src:url(" + ___CSS_LOADER_URL_REPLACEMENT_11___ + ") format(\"opentype\");font-weight:500;font-style:normal}@font-face{font-family:\"RostelecomBasis\";src:url(" + ___CSS_LOADER_URL_REPLACEMENT_12___ + ") format(\"opentype\");font-weight:500;font-style:italic}@font-face{font-family:\"RostelecomBasis\";src:url(" + ___CSS_LOADER_URL_REPLACEMENT_13___ + ") format(\"opentype\");font-weight:700;font-style:normal}:root{--toastify-color-success: #35c31f;--toastify-icon-color-success: var(--toastify-color-success);--toastify-z-index: 10002;--primary-color: #000;--error-color: #e3334e}html{overflow:hidden}body{margin:0;width:100%;height:100vh;height:100dvh;overflow:auto;font-family:var(--srx-ui-font-family-base);font-size:var(--srx-ui-font-size-14);line-height:var(--srx-ui-line-height-20)}body a{text-decoration:none}#potree_render_area{position:absolute;top:0px;bottom:0px;left:0px;right:0px;overflow:hidden;z-index:1}#root{width:100%;height:100%}input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active{transition:background-color 5000s ease-in-out 0s,color 5000s ease-in-out 0s;transition-delay:background-color 5000s,color 5000s}.slick-slide svg{transition:transform cubic-bezier(0.68, -0.55, 0.265, 1.55) !important}.sidebar{position:fixed;display:flex;height:100%;width:256px;flex-direction:column;justify-content:space-around;border-right:1px solid #efefef;background-color:#303030;padding:40px 0 40px 40px;color:#fff;font-weight:100;font-size:.7rem}.sidebar a{text-decoration:none}.sidebar__logo{position:absolute;top:18px;left:49px;width:110px}.sidebar-content__item--selected{color:#e8d2a3 !important}.main-content{padding-left:256px}.container{padding:0 40px;padding-top:24px}@media(max-width: 768px){.container{padding:0 20px;padding-top:24px}}.container-dense{padding:0 16px;padding-top:16px}.order-details{display:flex}.order-details__column{flex:1 1;padding:1rem}.order-details__column:first-child{padding-left:0}.order-details__column:last-child{padding-right:0}.order-details-info{display:flex}.order-details-info__item{flex:1 1;padding:4px 16px}.order-details-toolbar{display:flex;align-items:center;justify-content:space-between}.stats{display:flex;flex-wrap:wrap;justify-content:space-between;max-width:1280px;margin:0 auto}.stats__column{padding:1rem;min-width:47%;flex-wrap:wrap}.video{display:flex;justify-content:space-around;align-items:center;height:100vh}.icon{padding-right:32px}.icon:hover{color:#03a9f4}.row:hover{background-color:#efefef}.settings{max-width:700px;margin-right:auto}.list-item{padding:0 16px}.icon__arrow{cursor:pointer}.icon__arrow--left{padding-right:10px}.icon__arrow--right{padding-left:10px}.disable{pointer-events:none !important;color:#efefef !important}.modal-window{width:100vw;height:100vh;position:fixed;top:0;left:0;background-color:#000;z-index:10001}.modal-window__content{padding:35px}.modal-window__btn{color:#bfbfbf;position:fixed;top:15px;right:15px;background-color:#2b302c;cursor:pointer}.modal-window__btn:hover{background-color:#8b8c8b;color:#fff}.modal-window__tab{height:calc(100vh - 70px);display:flex !important;justify-content:space-around;align-items:center}.full-window-block{display:flex;flex-direction:column;align-items:center;justify-content:center}.full-window-block--login{background-color:#f3f4f5;background:#f3f4f5 url(" + ___CSS_LOADER_URL_REPLACEMENT_14___ + ") no-repeat;background-size:90vh}.login{width:25rem;padding:48px 16px 64px;position:relative}.login-title{font-size:24px;color:#e8d2a3;display:block;line-height:36px;border-left:3px solid #e8d2a3;margin-left:-16px;padding-left:32px;margin-bottom:1rem;display:flex;justify-content:space-between;align-items:center;padding-right:8px}.login-title__logo{width:64px;height:64px}.login__btn{background-color:#000 !important;margin:2rem 0}.login__link{font-weight:100;font-size:.9rem;color:#bfbfbf;cursor:pointer}.login__logo{position:absolute;bottom:50px;width:175px}.fadeTranslate-enter{opacity:0;transform:translate(0, 3vh);position:fixed}.fadeTranslate-enter.fadeTranslate-enter-active{opacity:1;transform:translate(0, 0);transition:opacity 200ms ease-in 200ms,transform 200ms ease-in-out 200ms}.fadeTranslate-exit{opacity:1;transform:translate(0, 0)}.fadeTranslate-exit.fadeTranslate-exit-active{opacity:0;transform:translate(0, 3vh);transition:opacity 100ms ease-in,transform 100ms ease-in-out}.fix-container{width:100%}.annotation-container{overflow:auto;max-height:300px}.annotation-container__img{width:100%;height:100%}.panorama__close-btn{position:absolute;right:5px;width:26px;height:26px;text-align:center}.viewer-menu-bottom-navigation{z-index:2}.viewer-menu-bottom-navigation>div>div>div>button>div>div{font-size:10px !important}.viewer-menu__measurement-btns{display:flex;justify-content:center;padding:0 16px 0 0}.viewer-menu-panels{overflow-y:auto;overflow-x:hidden;padding-bottom:66px}.viewer-content{width:100vw;height:100%;position:relative;display:flex}.viewer-content__background{background:url(" + ___CSS_LOADER_URL_REPLACEMENT_15___ + "),radial-gradient(#767676, #333333);display:flex;flex-direction:column;background-position:center;background-repeat:no-repeat;background-blend-mode:multiply}.viewer-measurement-details__main-header{text-align:center}.viewer-measurement-details__sub-header{color:rgba(0,0,0,.3);font-size:12px;margin-bottom:8px}.viewer-measurement-details__values{display:flex;flex-direction:column;justify-content:space-between}.tooltip{font-size:12px;padding:8px}.slick-prev:before,.slick-next:before{color:#000}.slick-prev{left:-32px}.slick-next{right:-32px}.custom{border:0;background-color:rgba(0,0,0,0);white-space:nowrap}.dragHandle{cursor:move}.L2DV-pane{z-index:1}.list__item{padding:8px;color:#000;background-color:#fff;cursor:pointer;font-size:12px}.list__item:hover{background-color:#e9e9e9}.list__item--active{color:#fff;background-color:#e8d2a3}.list__item--active:hover{background-color:#e8d2a3}.tooltip_btn{padding:10px;background-color:#e8d2a3;color:#fff;text-transform:uppercase;text-align:center;box-shadow:rgba(0,0,0,.12) 0px 1px 6px,rgba(0,0,0,.12) 0px 1px 4px;cursor:pointer}.my-label{position:absolute;width:100px;font-size:14px}.L2DV-profile-marker{width:15px;height:15px;border-radius:50%;background-color:#fff;border:2px solid #424242}.circle-picker{margin:16px auto 0 !important}.L2DV-label{font-family:\"IBMPlexSans\";color:#fff;text-align:center;font-size:18px}.L2DV-cluster-marker{margin-left:-30px !important;margin-top:-30px !important;cursor:pointer;user-select:none;-webkit-user-drag:none;width:max-content !important;outline:none}.L2DV-cluster-marker__person{margin-left:-20px !important;margin-top:-20px !important;width:50px !important;height:50px !important}.L2DV-tooptip{font-family:\"IBMPlexSans\"}.L2DV-control{clear:unset}.custom .L2DV-popup-tip,.custom .L2DV-popup-content-wrapper{background:#3c4051;color:#fff}.custom .L2DV-popup-content-wrapper{border-radius:25px}.custom .L2DV-popup-content{margin:2px}.button__empty{cursor:pointer;padding:0;margin:0;line-height:0;background-color:rgba(0,0,0,0);border:none}", "",{"version":3,"sources":["webpack://./tiptap/styles/_variables.scss","webpack://./tiptap/styles/_keyframe-animations.scss","webpack://./src/style.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAKI,cACH,wBAAA,CACA,qBAAA,CAPD,MASI,iCAAA,CACA,kCAAA,CACA,iCAAA,CAOF,4CAAA,CACA,6CAAA,CACA,4CAAA,CACA,4CAAA,CACA,6CAAA,CACA,6CAAA,CACA,6CAAA,CACA,6CAAA,CACA,6CAAA,CACA,6CAAA,CAGA,0CAAA,CACA,2CAAA,CACA,2CAAA,CACA,2CAAA,CACA,2CAAA,CACA,2CAAA,CACA,wCAAA,CACA,wCAAA,CACA,wCAAA,CACA,wCAAA,CAGA,8CAAA,CACA,+CAAA,CACA,+CAAA,CACA,+CAAA,CACA,+CAAA,CACA,8CAAA,CACA,+CAAA,CACA,+CAAA,CACA,+CAAA,CACA,+CAAA,CAGA,sCAAA,CACA,uCAAA,CACA,uCAAA,CACA,uCAAA,CACA,wCAAA,CACA,0CAAA,CACA,0CAAA,CACA,0CAAA,CACA,0CAAA,CACA,0CAAA,CAGA,2CAAA,CACA,4CAAA,CACA,4CAAA,CACA,4CAAA,CACA,2CAAA,CACA,0CAAA,CACA,yCAAA,CACA,yCAAA,CACA,yCAAA,CACA,0CAAA,CACA,4CAAA,CAGA,+CAAA,CACA,+CAAA,CACA,+CAAA,CACA,8CAAA,CACA,8CAAA,CACA,6CAAA,CACA,8CAAA,CACA,8CAAA,CACA,+CAAA,CACA,+CAAA,CACA,8CAAA,CAGA,+CAAA,CACA,+CAAA,CACA,+CAAA,CACA,+CAAA,CACA,+CAAA,CACA,8CAAA,CACA,+CAAA,CACA,+CAAA,CACA,+CAAA,CACA,+CAAA,CACA,8CAAA,CAGA,4CAAA,CACA,4CAAA,CACA,4CAAA,CACA,2CAAA,CACA,2CAAA,CACA,0CAAA,CACA,2CAAA,CACA,2CAAA,CACA,2CAAA,CACA,2CAAA,CACA,0CAAA,CAGA,+BAAA,CACA,4BAAA,CACA,qCAAA,CAOA,2LAAA,CAUA,yBAAA,CACA,uBAAA,CACA,wBAAA,CACA,sBAAA,CACA,uBAAA,CACA,oBAAA,CAMA,oCAAA,CACA,sCAAA,CACA,oCAAA,CACA,oEAAA,CACA,+DAAA,CACA,4DAAA,CACA,iEAAA,CACA,kEAAA,CAMA,wBAAA,CACA,6BAAA,CACA,4BAAA,CAGI,2EAIH,qBAAA,CACA,yFAAA,CAMH,MAME,2BAAA,CACA,6CAAA,CACA,kDAAA,CACA,+CAAA,CACA,gDAAA,CACA,4CAAA,CACA,8CAAA,CACA,gCAAA,CACA,kDAAA,CAIF,MACE,2BAAA,CACA,4CAAA,CACA,iDAAA,CACA,8CAAA,CACA,+CAAA,CACA,4CAAA,CACA,6CAAA,CACA,0CAAA,CACA,gDAAA,CAEA,8KAAA,CAMF,MACE,sCAAA,CACA,wCAAA,CACA,yCAAA,CACA,yCAAA,CACA,yCAAA,CACA,wCAAA,CACA,0CAAA,CACA,wCAAA,CACA,qCAAA,CAEA,uDAAA,CACA,wDAAA,CACA,yDAAA,CACA,yDAAA,CACA,yDAAA,CACA,wDAAA,CACA,0DAAA,CACA,wDAAA,CACA,oDAAA,CAGF,MACE,qCAAA,CACA,wCAAA,CACA,yCAAA,CACA,yCAAA,CACA,yCAAA,CACA,wCAAA,CACA,0CAAA,CACA,wCAAA,CACA,qCAAA,CAEA,sDAAA,CACA,wDAAA,CACA,wDAAA,CACA,wDAAA,CACA,wDAAA,CACA,uDAAA,CACA,0DAAA,CACA,wDAAA,CACA,qDAAA,CAIF,MACE,oCAAA,CACA,mCAAA,CACA,kCAAA,CACA,oCAAA,CACA,iCAAA,CACA,6CAAA,CACA,8CAAA,CACA,+CAAA,CACA,6CAAA,CAEA,6CAAA,CACA,4CAAA,CACA,2CAAA,CACA,6CAAA,CACA,0CAAA,CACA,0DAAA,CACA,8DAAA,CACA,8DAAA,CACA,6DAAA,CAGF,MACE,oCAAA,CACA,mCAAA,CACA,kCAAA,CACA,oCAAA,CACA,iCAAA,CACA,0CAAA,CACA,2CAAA,CACA,4CAAA,CACA,0CAAA,CAEA,6CAAA,CACA,4CAAA,CACA,2CAAA,CACA,6CAAA,CACA,0CAAA,CACA,8DAAA,CACA,6DAAA,CACA,6DAAA,CACA,4DAAA,CC1SF,kBACE,KACE,SAAA,CAEF,GACE,SAAA,CAAA,CAIJ,mBACE,KACE,SAAA,CAEF,GACE,SAAA,CAAA,CAIJ,kBACE,KACE,qBAAA,CAEF,GACE,kBAAA,CAAA,CAIJ,mBACE,KACE,kBAAA,CAEF,GACE,qBAAA,CAAA,CAIJ,gBACE,GACE,SAAA,CACA,qBAAA,CAEF,KACE,SAAA,CACA,kBAAA,CAAA,CAIJ,wBACE,KACE,6BAAA,CAEF,GACE,uBAAA,CAAA,CAIJ,0BACE,KACE,4BAAA,CAEF,GACE,uBAAA,CAAA,CAIJ,yBACE,KACE,6BAAA,CAEF,GACE,uBAAA,CAAA,CAIJ,2BACE,KACE,4BAAA,CAEF,GACE,uBAAA,CAAA,CAIJ,gBACE,KACE,sBAAA,CAEF,GACE,wBAAA,CAAA,CCnFJ,WACE,qBAAA,CACA,kHAAA,CAEA,eAAA,CACA,iBAAA,CAGF,WACE,qBAAA,CACA,kHAAA,CAEA,eAAA,CACA,iBAAA,CAGF,WACE,yBAAA,CACA,kHAAA,CAEA,eAAA,CACA,iBAAA,CAGF,WACE,yBAAA,CACA,kHAAA,CAEA,eAAA,CACA,iBAAA,CAGF,WACE,sBAAA,CACA,0DAAA,CACA,eAAA,CACA,iBAAA,CAGF,WACE,6BAAA,CACA,8DAAA,CACA,eAAA,CACA,iBAAA,CAGF,WACE,6BAAA,CACA,+DAAA,CACA,eAAA,CACA,iBAAA,CAGF,WACE,6BAAA,CACA,+DAAA,CACA,eAAA,CACA,iBAAA,CAGF,WACE,6BAAA,CACA,+DAAA,CACA,eAAA,CACA,iBAAA,CAGF,WACE,6BAAA,CACA,+DAAA,CACA,eAAA,CACA,iBAAA,CAGF,MACE,iCAAA,CACA,4DAAA,CACA,yBAAA,CACA,qBAAA,CACA,sBAAA,CAWF,KACE,eAAA,CAGF,KACE,QAAA,CACA,UAAA,CACA,YAAA,CACA,aAAA,CACA,aAAA,CACA,0CAAA,CACA,oCAAA,CACA,wCAAA,CACA,OACE,oBAAA,CAIJ,oBACE,iBAAA,CACA,OAAA,CACA,UAAA,CACA,QAAA,CACA,SAAA,CACA,eAAA,CACA,SAAA,CAGF,MACE,UAAA,CACA,WAAA,CAGF,+GAIE,2EAAA,CACA,mDAAA,CAGF,iBACE,sEAAA,CAGF,SACE,cAAA,CACA,YAAA,CAEA,WAAA,CACA,WCjJc,CDkJd,qBAAA,CACA,4BAAA,CACA,8BAAA,CACA,wBChJQ,CDiJR,wBAAA,CACA,UAAA,CACA,eAAA,CACA,eAAA,CACA,WACE,oBAAA,CAEF,eACE,iBAAA,CACA,QAAA,CACA,SAAA,CACA,WAAA,CAIE,iCACE,wBAAA,CAMR,cACE,kBC7Kc,CDgLhB,WACE,cAAA,CACA,gBAAA,CACA,yBAHF,WAII,cAAA,CACA,gBAAA,CAAA,CAIJ,iBACE,cAAA,CACA,gBCxLsB,CD2LxB,eACE,YAAA,CACA,uBACE,QAAA,CACA,YAAA,CACA,mCACE,cAAA,CAEF,kCACE,eAAA,CAGJ,oBACE,YAAA,CACA,0BACE,QAAA,CACA,gBAAA,CAGJ,uBACE,YAAA,CACA,kBAAA,CACA,6BAAA,CAIJ,OACE,YAAA,CACA,cAAA,CACA,6BAAA,CACA,gBAAA,CACA,aAAA,CACA,eACE,YAAA,CACA,aAAA,CACA,cAAA,CAIJ,OACE,YAAA,CACA,4BAAA,CACA,kBAAA,CACA,YAAA,CAGF,MACE,kBAAA,CACA,YACE,aAAA,CAKF,WACE,wBAAA,CAIJ,UACE,eAAA,CACA,iBAAA,CAIA,WACE,cAAA,CAKF,aACE,cAAA,CACA,mBACE,kBAAA,CAEF,oBACE,iBAAA,CAKN,SACE,8BAAA,CACA,wBAAA,CAGF,cACE,WAAA,CACA,YAAA,CACA,cAAA,CACA,KAAA,CACA,MAAA,CACA,qBAAA,CACA,aAAA,CACA,uBACE,YAAA,CAEF,mBACE,aCrRG,CDsRH,cAAA,CACA,QAAA,CACA,UAAA,CACA,wBAAA,CACA,cAAA,CACA,yBACE,wBAAA,CACA,UAAA,CAGJ,mBACE,yBAAA,CACA,uBAAA,CACA,4BAAA,CACA,kBAAA,CAIJ,mBACE,YAAA,CACA,qBAAA,CACA,kBAAA,CACA,sBAAA,CACA,0BACE,wBAAA,CACA,qEAAA,CACA,oBAAA,CAIJ,OACE,WAAA,CACA,sBAAA,CACA,iBAAA,CACA,aACE,cAAA,CACA,aC9Tc,CD+Td,aAAA,CACA,gBAAA,CACA,6BAAA,CACA,iBAAA,CACA,iBAAA,CACA,kBAAA,CACA,YAAA,CACA,6BAAA,CACA,kBAAA,CACA,iBAAA,CACA,mBACE,UAAA,CACA,WAAA,CAGJ,YACE,gCAAA,CACA,aAAA,CAEF,aACE,eAAA,CACA,eAAA,CACA,aCjVG,CDkVH,cAAA,CAEF,aACE,iBAAA,CACA,WAAA,CACA,WAAA,CAIJ,qBACE,SAAA,CACA,2BAAA,CACA,cAAA,CAGF,gDACE,SAAA,CACA,yBAAA,CACA,wEAAA,CAGF,oBACE,SAAA,CAEA,yBAAA,CAGF,8CACE,SAAA,CACA,2BAAA,CACA,4DAAA,CAGF,eACE,UAAA,CAGF,sBACE,aAAA,CACA,gBAAA,CACA,2BACE,UAAA,CACA,WAAA,CAIJ,qBACE,iBAAA,CACA,SAAA,CACA,UAAA,CACA,WAAA,CACA,iBAAA,CAKE,+BACE,SAAA,CACA,0DACE,yBAAA,CAGJ,+BACE,YAAA,CACA,sBAAA,CACA,kBAAA,CAEF,oBACE,eAAA,CACA,iBAAA,CACA,mBAAA,CAGJ,gBACE,WAAA,CAEA,WAAA,CACA,iBAAA,CACA,YAAA,CACA,4BACE,qFAAA,CACA,YAAA,CACA,qBAAA,CACA,0BAAA,CACA,2BAAA,CACA,8BAAA,CAIF,yCACE,iBAAA,CAEF,wCACE,oBAAA,CACA,cAAA,CACA,iBAAA,CAEF,oCACE,YAAA,CACA,qBAAA,CACA,6BAAA,CAKN,SACE,cAAA,CACA,WAAA,CAGF,sCAEE,UAAA,CAGF,YACE,UAAA,CAGF,YACE,WAAA,CAOF,QACE,QAAA,CACA,8BAAA,CACA,kBAAA,CAGF,YACE,WAAA,CAGF,cACE,SAAA,CAIA,YACE,WAAA,CACA,UAAA,CACA,qBAAA,CACA,cAAA,CACA,cAAA,CACA,kBACE,wBAAA,CAEF,oBACE,UAAA,CACA,wBC/eY,CDgfZ,0BACE,wBCjfU,CDuflB,aACE,YAAA,CACA,wBCzfgB,CD0fhB,UAAA,CACA,wBAAA,CACA,iBAAA,CACA,kEAAA,CACA,cAAA,CASF,UACE,iBAAA,CACA,WAAA,CACA,cAAA,CAGF,wBACE,UAAA,CACA,WAAA,CACA,iBAAA,CACA,qBAAA,CACA,wBAAA,CAEF,eACE,6BAAA,CAGF,eACE,yBAAA,CACA,UAAA,CACA,iBAAA,CACA,cAAA,CAGF,wBACE,4BAAA,CACA,2BAAA,CAGA,cAAA,CAEA,gBAAA,CACA,sBAAA,CACA,4BAAA,CAGA,YAAA,CACA,gCACE,4BAAA,CACA,2BAAA,CACA,qBAAA,CACA,sBAAA,CAGJ,iBACE,yBAAA,CAGF,iBACE,WAAA,CAIF,kEAEE,kBAAA,CACA,UAAA,CAEF,uCACE,kBAAA,CAGF,+BACE,UAAA,CAGF,eACE,cAAA,CACA,SAAA,CACA,QAAA,CACA,aAAA,CACA,8BAAA,CACA,WAAA","sourcesContent":[":root {\n  /****************** \n  Basics\n  ******************/\n\n    .tiptap {\n\toverflow-wrap: break-word;\n\ttext-size-adjust: none;\n    }\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\n  /****************** \n  Colors variables\n  ******************/\n\n  /* Gray alpha (light mode) */\n  --tt-gray-light-a-50: rgba(56, 56, 56, 0.04);\n  --tt-gray-light-a-100: rgba(15, 22, 36, 0.05);\n  --tt-gray-light-a-200: rgba(37, 39, 45, 0.1);\n  --tt-gray-light-a-300: rgba(47, 50, 55, 0.2);\n  --tt-gray-light-a-400: rgba(40, 44, 51, 0.42);\n  --tt-gray-light-a-500: rgba(52, 55, 60, 0.64);\n  --tt-gray-light-a-600: rgba(36, 39, 46, 0.78);\n  --tt-gray-light-a-700: rgba(35, 37, 42, 0.87);\n  --tt-gray-light-a-800: rgba(30, 32, 36, 0.95);\n  --tt-gray-light-a-900: rgba(29, 30, 32, 0.98);\n\n  /* Gray (light mode) */\n  --tt-gray-light-50: rgba(250, 250, 250, 1);\n  --tt-gray-light-100: rgba(244, 244, 245, 1);\n  --tt-gray-light-200: rgba(234, 234, 235, 1);\n  --tt-gray-light-300: rgba(213, 214, 215, 1);\n  --tt-gray-light-400: rgba(166, 167, 171, 1);\n  --tt-gray-light-500: rgba(125, 127, 130, 1);\n  --tt-gray-light-600: rgba(83, 86, 90, 1);\n  --tt-gray-light-700: rgba(64, 65, 69, 1);\n  --tt-gray-light-800: rgba(44, 45, 48, 1);\n  --tt-gray-light-900: rgba(34, 35, 37, 1);\n\n  /* Gray alpha (dark mode) */\n  --tt-gray-dark-a-50: rgba(232, 232, 253, 0.05);\n  --tt-gray-dark-a-100: rgba(231, 231, 243, 0.07);\n  --tt-gray-dark-a-200: rgba(238, 238, 246, 0.11);\n  --tt-gray-dark-a-300: rgba(239, 239, 245, 0.22);\n  --tt-gray-dark-a-400: rgba(244, 244, 255, 0.37);\n  --tt-gray-dark-a-500: rgba(236, 238, 253, 0.5);\n  --tt-gray-dark-a-600: rgba(247, 247, 253, 0.64);\n  --tt-gray-dark-a-700: rgba(251, 251, 254, 0.75);\n  --tt-gray-dark-a-800: rgba(253, 253, 253, 0.88);\n  --tt-gray-dark-a-900: rgba(255, 255, 255, 0.96);\n\n  /* Gray (dark mode) */\n  --tt-gray-dark-50: rgba(25, 25, 26, 1);\n  --tt-gray-dark-100: rgba(32, 32, 34, 1);\n  --tt-gray-dark-200: rgba(45, 45, 47, 1);\n  --tt-gray-dark-300: rgba(70, 70, 73, 1);\n  --tt-gray-dark-400: rgba(99, 99, 105, 1);\n  --tt-gray-dark-500: rgba(124, 124, 131, 1);\n  --tt-gray-dark-600: rgba(163, 163, 168, 1);\n  --tt-gray-dark-700: rgba(192, 192, 195, 1);\n  --tt-gray-dark-800: rgba(224, 224, 225, 1);\n  --tt-gray-dark-900: rgba(245, 245, 245, 1);\n\n  /* Brand colors */\n  --tt-brand-color-50: rgba(239, 238, 255, 1);\n  --tt-brand-color-100: rgba(222, 219, 255, 1);\n  --tt-brand-color-200: rgba(195, 189, 255, 1);\n  --tt-brand-color-300: rgba(157, 138, 255, 1);\n  --tt-brand-color-400: rgba(122, 82, 255, 1);\n  --tt-brand-color-500: rgba(98, 41, 255, 1);\n  --tt-brand-color-600: rgba(84, 0, 229, 1);\n  --tt-brand-color-700: rgba(75, 0, 204, 1);\n  --tt-brand-color-800: rgba(56, 0, 153, 1);\n  --tt-brand-color-900: rgba(43, 25, 102, 1);\n  --tt-brand-color-950: hsla(257, 100%, 9%, 1);\n\n  /* Green */\n  --tt-color-green-inc-5: hsla(129, 100%, 97%, 1);\n  --tt-color-green-inc-4: hsla(129, 100%, 92%, 1);\n  --tt-color-green-inc-3: hsla(131, 100%, 86%, 1);\n  --tt-color-green-inc-2: hsla(133, 98%, 78%, 1);\n  --tt-color-green-inc-1: hsla(137, 99%, 70%, 1);\n  --tt-color-green-base: hsla(147, 99%, 50%, 1);\n  --tt-color-green-dec-1: hsla(147, 97%, 41%, 1);\n  --tt-color-green-dec-2: hsla(146, 98%, 32%, 1);\n  --tt-color-green-dec-3: hsla(146, 100%, 24%, 1);\n  --tt-color-green-dec-4: hsla(144, 100%, 16%, 1);\n  --tt-color-green-dec-5: hsla(140, 100%, 9%, 1);\n\n  /* Yellow */\n  --tt-color-yellow-inc-5: hsla(50, 100%, 97%, 1);\n  --tt-color-yellow-inc-4: hsla(50, 100%, 91%, 1);\n  --tt-color-yellow-inc-3: hsla(50, 100%, 84%, 1);\n  --tt-color-yellow-inc-2: hsla(50, 100%, 77%, 1);\n  --tt-color-yellow-inc-1: hsla(50, 100%, 68%, 1);\n  --tt-color-yellow-base: hsla(52, 100%, 50%, 1);\n  --tt-color-yellow-dec-1: hsla(52, 100%, 41%, 1);\n  --tt-color-yellow-dec-2: hsla(52, 100%, 32%, 1);\n  --tt-color-yellow-dec-3: hsla(52, 100%, 24%, 1);\n  --tt-color-yellow-dec-4: hsla(51, 100%, 16%, 1);\n  --tt-color-yellow-dec-5: hsla(50, 100%, 9%, 1);\n\n  /* Red */\n  --tt-color-red-inc-5: hsla(11, 100%, 96%, 1);\n  --tt-color-red-inc-4: hsla(11, 100%, 88%, 1);\n  --tt-color-red-inc-3: hsla(10, 100%, 80%, 1);\n  --tt-color-red-inc-2: hsla(9, 100%, 73%, 1);\n  --tt-color-red-inc-1: hsla(7, 100%, 64%, 1);\n  --tt-color-red-base: hsla(7, 100%, 54%, 1);\n  --tt-color-red-dec-1: hsla(7, 100%, 41%, 1);\n  --tt-color-red-dec-2: hsla(5, 100%, 32%, 1);\n  --tt-color-red-dec-3: hsla(4, 100%, 24%, 1);\n  --tt-color-red-dec-4: hsla(3, 100%, 16%, 1);\n  --tt-color-red-dec-5: hsla(1, 100%, 9%, 1);\n\n  /* Basic colors */\n  --white: rgba(255, 255, 255, 1);\n  --black: rgba(14, 14, 17, 1);\n  --transparent: rgba(255, 255, 255, 0);\n\n  /****************** \n  Shadow variables\n  ******************/\n\n  /* Shadows Light */\n  --tt-shadow-elevated-md:\n    0px 16px 48px 0px rgba(17, 24, 39, 0.04),\n    0px 12px 24px 0px rgba(17, 24, 39, 0.04),\n    0px 6px 8px 0px rgba(17, 24, 39, 0.02),\n    0px 2px 3px 0px rgba(17, 24, 39, 0.02);\n\n  /************************************************** \n       Radius variables \n    **************************************************/\n\n  --tt-radius-xxs: 0.125rem; /* 2px */\n  --tt-radius-xs: 0.25rem; /* 4px */\n  --tt-radius-sm: 0.375rem; /* 6px */\n  --tt-radius-md: 0.5rem; /* 8px */\n  --tt-radius-lg: 0.75rem; /* 12px */\n  --tt-radius-xl: 1rem; /* 16px */\n\n  /************************************************** \n       Transition variables \n    **************************************************/\n\n  --tt-transition-duration-short: 0.1s;\n  --tt-transition-duration-default: 0.2s;\n  --tt-transition-duration-long: 0.64s;\n  --tt-transition-easing-default: cubic-bezier(0.46, 0.03, 0.52, 0.96);\n  --tt-transition-easing-cubic: cubic-bezier(0.65, 0.05, 0.36, 1);\n  --tt-transition-easing-quart: cubic-bezier(0.77, 0, 0.18, 1);\n  --tt-transition-easing-circ: cubic-bezier(0.79, 0.14, 0.15, 0.86);\n  --tt-transition-easing-back: cubic-bezier(0.68, -0.55, 0.27, 1.55);\n\n  /****************** \n  Contrast variables\n  ******************/\n\n  --tt-accent-contrast: 8%;\n  --tt-destructive-contrast: 8%;\n  --tt-foreground-contrast: 8%;\n\n  .tiptap {\n      &,\n      *,\n      ::before,\n      ::after {\n\t  box-sizing: border-box;\n\t  transition: none var(--tt-transition-duration-default)\n\t\t      var(--tt-transition-easing-default);\n      }\n  }\n}\n\n:root {\n  /************************************************** \n      Global colors \n  **************************************************/\n\n  /* Global colors - Light mode */\n  --tt-bg-color: var(--white);\n  --tt-border-color: var(--tt-gray-light-a-200);\n  --tt-border-color-tint: var(--tt-gray-light-a-100);\n  --tt-sidebar-bg-color: var(--tt-gray-light-100);\n  --tt-scrollbar-color: var(--tt-gray-light-a-200);\n  --tt-cursor-color: var(--tt-brand-color-500);\n  --tt-selection-color: rgba(157, 138, 255, 0.2);\n  --tt-card-bg-color: var(--white);\n  --tt-card-border-color: var(--tt-gray-light-a-100);\n}\n\n/* Global colors - Dark mode */\n.dark {\n  --tt-bg-color: var(--black);\n  --tt-border-color: var(--tt-gray-dark-a-200);\n  --tt-border-color-tint: var(--tt-gray-dark-a-100);\n  --tt-sidebar-bg-color: var(--tt-gray-dark-100);\n  --tt-scrollbar-color: var(--tt-gray-dark-a-200);\n  --tt-cursor-color: var(--tt-brand-color-400);\n  --tt-selection-color: rgba(122, 82, 255, 0.2);\n  --tt-card-bg-color: var(--tt-gray-dark-50);\n  --tt-card-border-color: var(--tt-gray-dark-a-50);\n\n  --tt-shadow-elevated-md:\n    0px 16px 48px 0px rgba(0, 0, 0, 0.5), 0px 12px 24px 0px rgba(0, 0, 0, 0.24),\n    0px 6px 8px 0px rgba(0, 0, 0, 0.22), 0px 2px 3px 0px rgba(0, 0, 0, 0.12);\n}\n\n/* Text colors */\n:root {\n  --tt-color-text-gray: hsl(45, 2%, 46%);\n  --tt-color-text-brown: hsl(19, 31%, 47%);\n  --tt-color-text-orange: hsl(30, 89%, 45%);\n  --tt-color-text-yellow: hsl(38, 62%, 49%);\n  --tt-color-text-green: hsl(148, 32%, 39%);\n  --tt-color-text-blue: hsl(202, 54%, 43%);\n  --tt-color-text-purple: hsl(274, 32%, 54%);\n  --tt-color-text-pink: hsl(328, 49%, 53%);\n  --tt-color-text-red: hsl(2, 62%, 55%);\n\n  --tt-color-text-gray-contrast: hsla(39, 26%, 26%, 0.15);\n  --tt-color-text-brown-contrast: hsla(18, 43%, 69%, 0.35);\n  --tt-color-text-orange-contrast: hsla(24, 73%, 55%, 0.27);\n  --tt-color-text-yellow-contrast: hsla(44, 82%, 59%, 0.39);\n  --tt-color-text-green-contrast: hsla(126, 29%, 60%, 0.27);\n  --tt-color-text-blue-contrast: hsla(202, 54%, 59%, 0.27);\n  --tt-color-text-purple-contrast: hsla(274, 37%, 64%, 0.27);\n  --tt-color-text-pink-contrast: hsla(331, 60%, 71%, 0.27);\n  --tt-color-text-red-contrast: hsla(8, 79%, 79%, 0.4);\n}\n\n.dark {\n  --tt-color-text-gray: hsl(0, 0%, 61%);\n  --tt-color-text-brown: hsl(18, 35%, 58%);\n  --tt-color-text-orange: hsl(25, 53%, 53%);\n  --tt-color-text-yellow: hsl(36, 54%, 55%);\n  --tt-color-text-green: hsl(145, 32%, 47%);\n  --tt-color-text-blue: hsl(202, 64%, 52%);\n  --tt-color-text-purple: hsl(270, 55%, 62%);\n  --tt-color-text-pink: hsl(329, 57%, 58%);\n  --tt-color-text-red: hsl(1, 69%, 60%);\n\n  --tt-color-text-gray-contrast: hsla(0, 0%, 100%, 0.09);\n  --tt-color-text-brown-contrast: hsla(17, 45%, 50%, 0.25);\n  --tt-color-text-orange-contrast: hsla(27, 82%, 53%, 0.2);\n  --tt-color-text-yellow-contrast: hsla(35, 49%, 47%, 0.2);\n  --tt-color-text-green-contrast: hsla(151, 55%, 39%, 0.2);\n  --tt-color-text-blue-contrast: hsla(202, 54%, 43%, 0.2);\n  --tt-color-text-purple-contrast: hsla(271, 56%, 60%, 0.18);\n  --tt-color-text-pink-contrast: hsla(331, 67%, 58%, 0.22);\n  --tt-color-text-red-contrast: hsla(0, 67%, 60%, 0.25);\n}\n\n/* Highlight colors */\n:root {\n  --tt-color-highlight-yellow: #fef9c3;\n  --tt-color-highlight-green: #dcfce7;\n  --tt-color-highlight-blue: #e0f2fe;\n  --tt-color-highlight-purple: #f3e8ff;\n  --tt-color-highlight-red: #ffe4e6;\n  --tt-color-highlight-gray: rgb(248, 248, 247);\n  --tt-color-highlight-brown: rgb(244, 238, 238);\n  --tt-color-highlight-orange: rgb(251, 236, 221);\n  --tt-color-highlight-pink: rgb(252, 241, 246);\n\n  --tt-color-highlight-yellow-contrast: #fbe604;\n  --tt-color-highlight-green-contrast: #c7fad8;\n  --tt-color-highlight-blue-contrast: #ceeafd;\n  --tt-color-highlight-purple-contrast: #e4ccff;\n  --tt-color-highlight-red-contrast: #ffccd0;\n  --tt-color-highlight-gray-contrast: rgba(84, 72, 49, 0.15);\n  --tt-color-highlight-brown-contrast: rgba(210, 162, 141, 0.35);\n  --tt-color-highlight-orange-contrast: rgba(224, 124, 57, 0.27);\n  --tt-color-highlight-pink-contrast: rgba(225, 136, 179, 0.27);\n}\n\n.dark {\n  --tt-color-highlight-yellow: #6b6524;\n  --tt-color-highlight-green: #509568;\n  --tt-color-highlight-blue: #6e92aa;\n  --tt-color-highlight-purple: #583e74;\n  --tt-color-highlight-red: #743e42;\n  --tt-color-highlight-gray: rgb(47, 47, 47);\n  --tt-color-highlight-brown: rgb(74, 50, 40);\n  --tt-color-highlight-orange: rgb(92, 59, 35);\n  --tt-color-highlight-pink: rgb(78, 44, 60);\n\n  --tt-color-highlight-yellow-contrast: #58531e;\n  --tt-color-highlight-green-contrast: #47855d;\n  --tt-color-highlight-blue-contrast: #5e86a1;\n  --tt-color-highlight-purple-contrast: #4c3564;\n  --tt-color-highlight-red-contrast: #643539;\n  --tt-color-highlight-gray-contrast: rgba(255, 255, 255, 0.094);\n  --tt-color-highlight-brown-contrast: rgba(184, 101, 69, 0.25);\n  --tt-color-highlight-orange-contrast: rgba(233, 126, 37, 0.2);\n  --tt-color-highlight-pink-contrast: rgba(220, 76, 145, 0.22);\n}\n","@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes zoomIn {\n  from {\n    transform: scale(0.95);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n@keyframes zoomOut {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(0.95);\n  }\n}\n\n@keyframes zoom {\n  0% {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes slideFromTop {\n  from {\n    transform: translateY(-0.5rem);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideFromRight {\n  from {\n    transform: translateX(0.5rem);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideFromLeft {\n  from {\n    transform: translateX(-0.5rem);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideFromBottom {\n  from {\n    transform: translateY(0.5rem);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n","@use \"variables\" as *;\n\n@use \"../tiptap/styles/_variables.scss\" as *;\n@use \"../tiptap/styles/_keyframe-animations.scss\" as *;\n\n@font-face {\n  font-family: \"TTLakes\";\n  src: url(\"/static/fonts/TTLakes-Regular.woff2\") format(\"woff2\"),\n    url(\"/static/fonts/TTLakes-Regular.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"TTLakes\";\n  src: url(\"/static/fonts/TTLakes-Medium.woff2\") format(\"woff2\"),\n    url(\"/static/fonts/TTLakes-Medium.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"IBMPlexSans\";\n  src: url(\"/static/fonts/IBMPlexSans-Regular.woff2\") format(\"woff2\"),\n    url(\"/static/fonts/IBMPlexSans-Regular.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"IBMPlexSans\";\n  src: url(\"/static/fonts/IBMPlexSans-Medium.woff2\") format(\"woff2\"),\n    url(\"/static/fonts/IBMPlexSans-Medium.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"isocpeur\";\n  src: url(\"/static/fonts/Isocpeur-Regular.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"RostelecomBasis\";\n  src: url(\"/static/rostelecom/fonts/RostelecomBasis-Regular.otf\") format(\"opentype\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"RostelecomBasis\";\n  src: url(\"/static/rostelecom/fonts/RostelecomBasis-Light.otf\") format(\"opentype\");\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"RostelecomBasis\";\n  src: url(\"/static/rostelecom/fonts/RostelecomBasis-Medium.otf\") format(\"opentype\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"RostelecomBasis\";\n  src: url(\"/static/rostelecom/fonts/RostelecomBasis-MediumHighlight.otf\") format(\"opentype\");\n  font-weight: 500;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"RostelecomBasis\";\n  src: url(\"/static/rostelecom/fonts/RostelecomBasis-Bold.otf\") format(\"opentype\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n:root {\n  --toastify-color-success: #35c31f;\n  --toastify-icon-color-success: var(--toastify-color-success);\n  --toastify-z-index: 10002;\n  --primary-color: #000;\n  --error-color: #e3334e;\n}\n\n.theme-base {\n  // font-family: \"IBMPlexSans\", \"Open Sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.theme-rostelecom {\n  // font-family: \"RostelecomBasis\", \"Open Sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\nhtml {\n  overflow: hidden;\n}\n\nbody {\n  margin: 0;\n  width: 100%;\n  height: 100vh;\n  height: 100dvh;\n  overflow: auto;\n  font-family: var(--srx-ui-font-family-base);\n  font-size: var(--srx-ui-font-size-14);\n  line-height: var(--srx-ui-line-height-20);\n  a {\n    text-decoration: none;\n  }\n}\n\n#potree_render_area {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  overflow: hidden;\n  z-index: 1;\n}\n\n#root {\n  width: 100%;\n  height: 100%;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  transition: background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s;\n  transition-delay: background-color 5000s, color 5000s;\n}\n\n.slick-slide svg {\n  transition: transform cubic-bezier(0.68, -0.55, 0.265, 1.55) !important;\n}\n\n.sidebar {\n  position: fixed;\n  display: flex;\n  //height: calc(100vh - 2 * #{$sidebar-padding});\n  height: 100%;\n  width: $sidebar-width;\n  flex-direction: column;\n  justify-content: space-around;\n  border-right: 1px solid #efefef;\n  background-color: $dark-bg;\n  padding: $sidebar-padding 0 $sidebar-padding $sidebar-padding;\n  color: #fff;\n  font-weight: 100;\n  font-size: 0.7rem;\n  a {\n    text-decoration: none;\n  }\n  &__logo {\n    position: absolute;\n    top: 18px;\n    left: 49px;\n    width: 110px;\n  }\n  &-content {\n    &__item {\n      &--selected {\n        color: $materialPrimary !important;\n      }\n    }\n  }\n}\n\n.main-content {\n  padding-left: $sidebar-width;\n}\n\n.container {\n  padding: 0 $sidebar-padding;\n  padding-top: 24px; //$sidebar-padding;\n  @media (max-width: 768px) {\n    padding: 0 $sidebar-padding-mobile;\n    padding-top: 24px; //$sidebar-padding;\n  }\n}\n\n.container-dense {\n  padding: 0 $sidebar-padding-dense;\n  padding-top: $sidebar-padding-dense;\n}\n\n.order-details {\n  display: flex;\n  &__column {\n    flex: 1 1;\n    padding: 1rem;\n    &:first-child {\n      padding-left: 0;\n    }\n    &:last-child {\n      padding-right: 0;\n    }\n  }\n  &-info {\n    display: flex;\n    &__item {\n      flex: 1 1;\n      padding: 4px 16px;\n    }\n  }\n  &-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.stats {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  max-width: 1280px;\n  margin: 0 auto;\n  &__column {\n    padding: 1rem;\n    min-width: 47%;\n    flex-wrap: wrap;\n  }\n}\n\n.video {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  height: 100vh;\n}\n\n.icon {\n  padding-right: 32px;\n  &:hover {\n    color: #03a9f4;\n  }\n}\n\n.row {\n  &:hover {\n    background-color: #efefef;\n  }\n}\n\n.settings {\n  max-width: 700px;\n  margin-right: auto;\n}\n\n.list {\n  &-item {\n    padding: 0 16px;\n  }\n}\n\n.icon {\n  &__arrow {\n    cursor: pointer;\n    &--left {\n      padding-right: 10px;\n    }\n    &--right {\n      padding-left: 10px;\n    }\n  }\n}\n\n.disable {\n  pointer-events: none !important;\n  color: $gray-light !important;\n}\n\n.modal-window {\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: #000;\n  z-index: 10001;\n  &__content {\n    padding: 35px;\n  }\n  &__btn {\n    color: $gray;\n    position: fixed;\n    top: 15px;\n    right: 15px;\n    background-color: rgb(43, 48, 44); //----- feature/SD-404_video-monitoring\n    cursor: pointer;\n    &:hover {\n      background-color: #8b8c8b; //----- feature/SD-404_video-monitoring\n      color: #fff;\n    }\n  }\n  &__tab {\n    height: calc(100vh - 70px);\n    display: flex !important;\n    justify-content: space-around;\n    align-items: center;\n  }\n}\n\n.full-window-block {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  &--login {\n    background-color: rgb(243, 244, 245);\n    background: rgb(243, 244, 245) url(\"/static/white_half.png\") no-repeat;\n    background-size: 90vh;\n  }\n}\n\n.login {\n  width: 25rem;\n  padding: 48px 16px 64px;\n  position: relative;\n  &-title {\n    font-size: 24px;\n    color: $materialPrimary;\n    display: block;\n    line-height: 36px;\n    border-left: 3px solid $materialPrimary;\n    margin-left: -16px;\n    padding-left: 32px;\n    margin-bottom: 1rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-right: 8px;\n    &__logo {\n      width: 64px;\n      height: 64px;\n    }\n  }\n  &__btn {\n    background-color: #000 !important;\n    margin: 2rem 0;\n  }\n  &__link {\n    font-weight: 100;\n    font-size: 0.9rem;\n    color: $gray;\n    cursor: pointer;\n  }\n  &__logo {\n    position: absolute;\n    bottom: 50px;\n    width: 175px;\n  }\n}\n\n.fadeTranslate-enter {\n  opacity: 0;\n  transform: translate(0, 3vh);\n  position: fixed;\n}\n\n.fadeTranslate-enter.fadeTranslate-enter-active {\n  opacity: 1;\n  transform: translate(0, 0);\n  transition: opacity 200ms ease-in 200ms, transform 200ms ease-in-out 200ms;\n}\n\n.fadeTranslate-exit {\n  opacity: 1;\n\n  transform: translate(0, 0);\n}\n\n.fadeTranslate-exit.fadeTranslate-exit-active {\n  opacity: 0;\n  transform: translate(0, 3vh);\n  transition: opacity 100ms ease-in, transform 100ms ease-in-out;\n}\n\n.fix-container {\n  width: 100%;\n}\n\n.annotation-container {\n  overflow: auto;\n  max-height: 300px;\n  &__img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.panorama__close-btn {\n  position: absolute;\n  right: 5px;\n  width: 26px;\n  height: 26px;\n  text-align: center;\n}\n\n.viewer {\n  &-menu {\n    &-bottom-navigation {\n      z-index: 2;\n      & > div > div > div > button > div > div {\n        font-size: 10px !important;\n      }\n    }\n    &__measurement-btns {\n      display: flex;\n      justify-content: center;\n      padding: 0 16px 0 0;\n    }\n    &-panels {\n      overflow-y: auto;\n      overflow-x: hidden;\n      padding-bottom: 66px;\n    }\n  }\n  &-content {\n    width: 100vw;\n    // height: calc(100% - 60px);\n    height: 100%;\n    position: relative;\n    display: flex;\n    &__background {\n      background: url(\"/static/app_logo_bg.png\"), radial-gradient(#767676, #333333);\n      display: flex;\n      flex-direction: column;\n      background-position: center;\n      background-repeat: no-repeat;\n      background-blend-mode: multiply;\n    }\n  }\n  &-measurement-details {\n    &__main-header {\n      text-align: center;\n    }\n    &__sub-header {\n      color: rgba(0, 0, 0, 0.3);\n      font-size: 12px;\n      margin-bottom: 8px;\n    }\n    &__values {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n    }\n  }\n}\n\n.tooltip {\n  font-size: 12px;\n  padding: 8px;\n}\n\n.slick-prev:before,\n.slick-next:before {\n  color: black;\n}\n\n.slick-prev {\n  left: -32px;\n}\n\n.slick-next {\n  right: -32px;\n}\n\n//.L2DV-div-icon {\n//\n//}\n\n.custom {\n  border: 0;\n  background-color: transparent;\n  white-space: nowrap;\n}\n\n.dragHandle {\n  cursor: move;\n}\n\n.L2DV-pane {\n  z-index: 1;\n}\n\n.list {\n  &__item {\n    padding: 8px;\n    color: black;\n    background-color: white;\n    cursor: pointer;\n    font-size: 12px;\n    &:hover {\n      background-color: #e9e9e9;\n    }\n    &--active {\n      color: white;\n      background-color: $materialPrimary;\n      &:hover {\n        background-color: $materialPrimary;\n      }\n    }\n  }\n}\n\n.tooltip_btn {\n  padding: 10px;\n  background-color: $materialPrimary;\n  color: white;\n  text-transform: uppercase;\n  text-align: center;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  cursor: pointer;\n}\n\n.tooltip_btn:hover {\n}\n\n.tootup_btn:active {\n}\n\n.my-label {\n  position: absolute;\n  width: 100px;\n  font-size: 14px;\n}\n\n.L2DV-profile-marker {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background-color: white;\n  border: 2px solid #424242;\n}\n.circle-picker {\n  margin: 16px auto 0 !important;\n}\n\n.L2DV-label {\n  font-family: \"IBMPlexSans\";\n  color: #ffffff;\n  text-align: center;\n  font-size: 18px;\n}\n\n.L2DV-cluster-marker {\n  margin-left: -30px !important;\n  margin-top: -30px !important;\n  // border-radius: 7px;\n  // background-color: rgba(0, 0, 0, 0.5);\n  cursor: pointer;\n  // border: 1px solid white;\n  user-select: none;\n  -webkit-user-drag: none;\n  width: max-content !important;\n  // width: 60px !important;\n  // height: 60px !important;\n  outline: none;\n  &__person {\n    margin-left: -20px !important;\n    margin-top: -20px !important;\n    width: 50px !important;\n    height: 50px !important;\n  }\n}\n.L2DV-tooptip {\n  font-family: \"IBMPlexSans\";\n}\n\n.L2DV-control {\n  clear: unset;\n}\n\n/* css to customize L2DV default styles  */\n.custom .L2DV-popup-tip,\n.custom .L2DV-popup-content-wrapper {\n  background: #3c4051;\n  color: #ffffff;\n}\n.custom .L2DV-popup-content-wrapper {\n  border-radius: 25px;\n}\n\n.custom .L2DV-popup-content {\n  margin: 2px;\n}\n\n.button__empty {\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  line-height: 0;\n  background-color: transparent;\n  border: none;\n}\n","$sidebar-width: 256px;\n$sidebar-padding: 40px;\n$sidebar-padding-mobile: 20px;\n$sidebar-padding-dense: 16px;\n\n$dark-bg: rgb(48, 48, 48);\n\n$blue500: #03a9f4;\n$materialPrimary: #e8d2a3;\n$materialSecondary: #dfa529;\n$materialThird: #bd8e2d;\n$gray-light: #efefef;\n$gray: #bfbfbf;\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ __webpack_exports__.A = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 44442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89068);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37631);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_translator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34678);




const initObj = {
  // we init with resources
  resources: {
    en: {
      translations: {
        surface_points: "Surface points",
        "3d model": "3D Model",
        "3d model_plural": "3D Models",
        address: "Address",
        "admin panel": "Admin panel",
        "admin account setup": "Admin account setup",
        "administration modules": "Module administration",
        "administration platform": "Platform administration",
        "template constructor": "Template constructor",
        aggressive: "Aggressive",
        align: "Align",
        align_completed: "Align completed",
        altitude: "Altitude",
        analysis: "Analysis",
        analytics: "Analytics",
        annotation: "Annotation",
        "antennas height": "Antennas height",
        appearance: "Appearance",
        april: "April",
        "plan area": "Plan area",
        area: "Area",
        august: "August",
        avatar: "Avatar",
        back: "Back",
        build: "Build",
        bulldozer: "Bulldozer",
        "cadastral data": "Cadastral data",
        "calculate dynamic": "Calculate dynamic",
        cancel: "Cancel",
        "choose file": "Choose file",
        cm: "cm",
        comment: "Comment",
        compare: "Compare",
        "comparisons list": "Comparisons list",
        "concrete mixer": "Concrete mixer",
        construction: "Construction",
        contacts: "Contacts",
        contours: "Contours",
        "contracting speed": "Contracting speed",
        "coordinates of points": "Coordinates of points",
        "coordinates system": "Coordinates system",
        created: "Created",
        current: "Current",
        current_plural: "Current",
        dashboard: "Dashboard",
        data: "{{count}} Data",
        date__value: "{{ date, MM.DD.YY }}",
        date_gantt__value: "{{ date, DD-MM-YYYY}}",
        day: "Day",
        december: "December",
        dense_cloud: "Dense cloud",
        dense_cloud_completed: "Dense cloud completed",
        depth_maps: "Depth maps",
        depth_maps_completed: "Depth maps completed",
        description: "Description",
        "deviation threshold": "Deviation threshold",
        "digital model": "Digital model",
        distance: "Distance",
        documentation: "Documentation",
        download: "Download",
        "dump truck": "Dump truck",
        "elevation map": "Elevation map",
        "email message on new target add": "Email message on new target add",
        "email message on target update": "Email message on target update",
        "enter email": "Enter email",
        "equipment audit": "Equipment audit",
        example: "Example",
        export: "Export",
        export_completed: "Export completed",
        excavator: "Excavator",
        "fact model for comparing": "'Fact' model for comparing",
        february: "February",
        feed: "Feed",
        "feed is empty": "Feed is empty",
        "field survey": "Field survey",
        files: "Files",
        "filter placeholder": "Name or address description",
        flight: "Flight",
        flight_plural: "Flights",
        "forget your password": "Forget your password",
        "from documentation": "From documentation",
        fulldate__value: "{{ date, MM.DD.YY HH:mm}}",
        general: "General",
        "height profile": "Height profile",
        high: "High",
        "incorrect user name or password": "Incorrect user name or password",
        info: "Info",
        january: "January",
        july: "July",
        june: "June",
        language: "Language",
        language__value: "en",
        "last update": "Last update",
        latitude: "Latitude",
        layers: "Layers",
        "leave a comment": "Leave a comment",
        length: "Length",
        loader: "Loader",
        "log in": "Log in",
        "log out": "Log out",
        longitude: "Longitude",
        low: "Low",
        m: "m",
        management: "Planning",
        march: "March",
        may: "May",
        measurement: "Measurement",
        measurement_plural: "Measurements",
        middle: "Middle",
        moderate: "Moderate",
        month: "Month",
        name: "Name",
        next: "Next",
        "no data": "No data",
        november: "November",
        "number of lagging targets": "Number of lagging targets",
        october: "October",
        opacity: "Opacity",
        "order survey": "Order survey",
        orthophoto: "Orthophoto plan",
        orthophoto_plural: "Orthophoto plans",
        overlay: "Overlay",
        overview: "Overview",
        page: "Page",
        panorama: "Panorama",
        panorama_plural: "Panoramas",
        params: "Params",
        password: "Password",
        "plan perimeter": "Plan perimeter",
        perimeter: "Perimeter",
        phone: "Phone",
        photo: "Photo",
        photo_plural: "Photos",
        pipelayer: "Pipelayer",
        "plan-fact analyze": "Plan-fact analyze",
        "plan length": "Plan length",
        "points number": "Points number",
        "point cloud": "Point cloud",
        "profile width": "Profile width",
        project: "Project",
        "ready for uploading": "Ready for uploading",
        remarks: "Remarks",
        recognition: "Recognition",
        "request error": "Oops, request error",
        "request success": "Your request received",
        "road roller": "Road roller",
        save: "Save",
        "schedule control": "Schedule control",
        search: "Search",
        "search area": "Search area",
        send: "Send",
        september: "September",
        settings: "Settings",
        "show on map": "Show on map",
        statistics: "Statistics",
        submit: "Submit",
        "supported formats": "Supported formats",
        survey: "Survey",
        "survey request": "Survey request",
        targets: "Targets",
        "targets splitting by status": "Targets splitting by status",
        "targets quantity": "Targets quantity",
        tool: "Tools",
        tool_plural: "Tools",
        "total percentage of targets readiness": "Total percentage of targets readiness",
        tower: "Tower",
        type: "Type",
        "upload file text": "Try dropping some files here, or click to select files to upload",
        "uploaded files": "Uploaded files",
        user: "User",
        "user name": "User name",
        "very low": "Very low",
        video: "Video",
        video_plural: "Videos",
        view: "View",
        volume: "Volume",
        "volume 3D": "Volume 3D",
        "volume above bp": "Fill",
        "volume below bp": "Cut",
        week: "Week",
        year: "Year",
        "profile label": "Profile",
        "angle label": "Angle",
        videoCamera: "Video camera",
        videoCamera__plural: "Video cameras",
        processes: "Work processes",
        reviews: "Document Approval",
        premises: "Premises",
        assets: "Assets",
        logout: "Logout",
        "loading administration platform": "Loading platform administration module",
        "loading administration modules": "Loading module administration",
        "try again": "Try again",
        "refresh without cache": "Refresh without cache",
        "loading request module": "Loading request module",
        "you don't have a selected company": "You don't have a selected company",
        "You don't have an active company": "No active company",
        "No active company hint": "Sign in with another account that is linked to an organization, or ask your administrator to grant access.",
        "Change the account": "Change account",
        "you don't have permission to view this module": "You don't have permission to view this module",
        "loading assets module": "Loading assets module",
        "An error has occurred": "An error has occurred",
        "Try refreshing the application or contact us at": "Try refreshing the application or contact us at",
        "Copy error log": "Copy error log",
        "Return to the main page": "Return to the main page",
        "Copied! \u2713": "Copied! \u2713"
      }
    },
    ru: {
      translations: {
        surface_points: "\u0422\u043E\u0447\u043A\u0438 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438",
        "3d model_0": "3D \u041C\u043E\u0434\u0435\u043B\u044C",
        "3d model_1": "3D \u041C\u043E\u0434\u0435\u043B\u0438",
        address: "\u0410\u0434\u0440\u0435\u0441",
        "admin panel": "\u041F\u0430\u043D\u0435\u043B\u044C \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430",
        "administration modules": "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043C\u043E\u0434\u0443\u043B\u0435\u0439",
        "admin account setup": "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439",
        "administration platform": "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B",
        "template constructor": "\u041A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440 \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432",
        aggressive: "\u0410\u0433\u0440\u0435\u0441\u0441\u0438\u0432\u043D\u0430\u044F",
        align: "\u0412\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435",
        align_completed: "\u0412\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        altitude: "\u0412\u044B\u0441\u043E\u0442\u0430",
        analysis: "\u0410\u043D\u0430\u043B\u0438\u0437",
        analytics: "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430",
        annotation: "\u0410\u043D\u043D\u043E\u0442\u0430\u0446\u0438\u044F",
        "antennas height": "\u0412\u044B\u0441\u043E\u0442\u0430 \u0430\u043D\u0442\u0435\u043D\u043D",
        appearance: "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
        april: "\u0410\u043F\u0440\u0435\u043B\u044C",
        "plan area": "\u041F\u043B\u0430\u043D\u043E\u0432\u0430\u044F \u043F\u043B\u043E\u0449\u0430\u0434\u044C",
        area: "\u041F\u043B\u043E\u0449\u0430\u0434\u044C",
        august: "\u0410\u0432\u0433\u0443\u0441\u0442",
        avatar: "\u0410\u0432\u0430\u0442\u0430\u0440",
        back: "\u041D\u0430\u0437\u0430\u0434",
        build: "\u041F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u044C",
        bulldozer: "\u0411\u0443\u043B\u044C\u0434\u043E\u0437\u0435\u0440",
        "cadastral data": "\u041A\u0430\u0434\u0430\u0441\u0442\u0440\u043E\u0432\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
        "calculate dynamic": "\u0412\u044B\u0447\u0438\u0441\u043B\u0438\u0442\u044C \u0434\u0438\u043D\u0430\u043C\u0438\u043A\u0443",
        cancel: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
        "choose file": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0430\u0439\u043B",
        cm: "\u0441\u043C",
        "comparisons list": "\u0421\u043F\u0438\u0441\u043E\u043A \u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u0439",
        construction: "\u0421\u0442\u0440\u043E\u0439\u043A\u0430",
        "contracting speed": "\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
        "coordinates of points": "\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B \u0442\u043E\u0447\u0435\u043A",
        "coordinates system": "\u0421\u0438\u0441\u0442\u0435\u043C\u0430 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442",
        comment: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439",
        compare: "\u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C",
        "concrete mixer": "\u0411\u0435\u0442\u043E\u043D\u043E\u043C\u0435\u0448\u0430\u043B\u043A\u0430",
        contacts: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B",
        contours: "\u041A\u043E\u043D\u0442\u0443\u0440\u044B",
        created: "\u0421\u043E\u0437\u0434\u0430\u043D\u043E",
        current_0: "\u0422\u0435\u043A\u0443\u0449\u0435\u0435",
        current_1: "\u0422\u0435\u043A\u0443\u0449\u0438\u0435",
        dashboard: "\u0414\u0430\u0448\u0431\u043E\u0440\u0434",
        data: "\u041C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B",
        date__value: "{{ date, DD.MM.YY}}",
        date_gantt__value: "{{ date, DD-MM-YYYY}}",
        day: "\u0414\u0435\u043D\u044C",
        december: "\u0414\u0435\u043A\u0430\u0431\u0440\u044C",
        dense_cloud: "\u041F\u043E\u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 \u043F\u043B\u043E\u0442\u043D\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u043A\u0430",
        dense_cloud_completed: "\u041F\u043B\u043E\u0442\u043D\u043E\u0435 \u043E\u0431\u043B\u0430\u043A\u043E \u043F\u043E\u0441\u0442\u0440\u043E\u0435\u043D\u043E",
        depth_maps: "\u041F\u043E\u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 \u043A\u0430\u0440\u0442 \u0433\u043B\u0443\u0431\u0438\u043D\u044B",
        depth_maps_completed: "\u041A\u0430\u0440\u0442\u044B \u0433\u043B\u0443\u0431\u0438\u043D\u044B \u043F\u043E\u0441\u0442\u0440\u043E\u0435\u043D\u044B",
        description: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
        "deviation threshold": "\u041F\u043E\u0440\u043E\u0433 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0438\u044F",
        "digital model_0": "\u0426\u0438\u0444\u0440\u043E\u0432\u0430\u044F \u043C\u043E\u0434\u0435\u043B\u044C",
        "digital model_1": "\u0426\u0438\u0444\u0440\u043E\u0432\u044B\u0435 \u043C\u043E\u0434\u0435\u043B\u0438",
        distance: "\u0420\u0430\u0441\u0441\u0442\u043E\u044F\u043D\u0438\u0435",
        documentation: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044F",
        download: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C",
        "dump truck": "\u0410\u0432\u0442\u043E\u0441\u0430\u043C\u043E\u0441\u0432\u0430\u043B",
        "elevation map": "\u041A\u0430\u0440\u0442\u0430 \u0432\u044B\u0441\u043E\u0442",
        "email message on new target add": "Email \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043F\u0440\u0438 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u043D\u043E\u0432\u043E\u0433\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u0430",
        "email message on target update": "Email \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043F\u0440\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",
        "enter email": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 email",
        "equipment audit": "\u0410\u0443\u0434\u0438\u0442 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F",
        example: "\u041F\u0440\u0438\u043C\u0435\u0440",
        excavator: "\u042D\u043A\u0441\u043A\u0430\u0432\u0430\u0442\u043E\u0440",
        export: "\u0412\u044B\u0433\u0440\u0443\u0437\u043A\u0430",
        export_completed: "\u0412\u044B\u0433\u0440\u0443\u0437\u043A\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430",
        "fact model for comparing": "\u041C\u043E\u0434\u0435\u043B\u044C '\u0444\u0430\u043A\u0442\u0430' \u0434\u043B\u044F \u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u044F",
        february: "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
        feed: "\u041B\u0435\u043D\u0442\u0430",
        "feed is empty": "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445",
        "field survey": "\u041E\u0431\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0435 \u0443\u0447\u0430\u0441\u0442\u043A\u0430",
        files: "\u0424\u0430\u0439\u043B\u044B",
        "filter placeholder": "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",
        flight_0: "\u0421\u044A\u0451\u043C\u043A\u0430",
        flight_1: "\u0421\u044A\u0451\u043C\u043A\u0438",
        "forget your password": "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
        "from documentation": "\u0418\u0437 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u0438",
        fulldate__value: "{{ date, DD.MM.YY HH:mm}}",
        general: "\u041E\u0431\u0449\u0435\u0435",
        "height profile": "\u041F\u0440\u043E\u0444\u0438\u043B\u044C \u0432\u044B\u0441\u043E\u0442\u044B",
        high: "\u0412\u044B\u0441\u043E\u043A\u043E\u0435",
        "incorrect user name or password": "\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0435 \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
        info: "\u0414\u0430\u043D\u043D\u044B\u0435",
        inspections: "\u0418\u043D\u0441\u043F\u0435\u043A\u0446\u0438\u0438",
        january: "\u042F\u043D\u0432\u0430\u0440\u044C",
        july: "\u0418\u044E\u043B\u044C",
        june: "\u0418\u044E\u043D\u044C",
        language: "\u042F\u0437\u044B\u043A",
        language__value: "ru",
        "last update": "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435",
        latitude: "\u0428\u0438\u0440\u043E\u0442\u0430",
        layers: "\u0421\u043B\u043E\u0438",
        "leave a comment": "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439",
        length: "\u0414\u043B\u0438\u043D\u0430",
        loader: "\u041F\u043E\u0433\u0440\u0443\u0437\u0447\u0438\u043A",
        "log in": "\u0412\u043E\u0439\u0442\u0438",
        "log out": "\u0412\u044B\u0439\u0442\u0438",
        longitude: "\u0414\u043E\u043B\u0433\u043E\u0442\u0430",
        low: "\u041D\u0438\u0437\u043A\u043E\u0435",
        m: "\u043C",
        management: "\u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
        march: "\u041C\u0430\u0440\u0442",
        measurement_0: "\u0418\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0435",
        measurement_1: "\u0418\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F",
        middle: "\u0421\u0440\u0435\u0434\u043D\u0435\u0435",
        moderate: "\u0423\u043C\u0435\u0440\u0435\u043D\u043D\u0430\u044F",
        month: "\u041C\u0435\u0441\u044F\u0446",
        name: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
        next: "\u0414\u0430\u043B\u0435\u0435",
        "no data": "\u041C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442",
        november: "\u041D\u043E\u044F\u0431\u0440\u044C",
        "number of lagging targets": "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043E\u0442\u0441\u0442\u0430\u044E\u0449\u0438\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432",
        october: "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
        opacity: "\u041F\u0440\u043E\u0437\u0440\u0430\u0447\u043D\u043E\u0441\u0442\u044C",
        "order survey": "\u0417\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u044A\u0451\u043C\u043A\u0443",
        orthophoto_0: "\u041E\u0440\u0442\u043E\u0444\u043E\u0442\u043E\u043F\u043B\u0430\u043D",
        orthophoto_1: "\u041E\u0440\u0442\u043E\u0444\u043E\u0442\u043E\u043F\u043B\u0430\u043D\u044B",
        overlay: "\u041D\u0430\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
        overview: "\u041E\u0431\u0437\u043E\u0440",
        page: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
        panorama_0: "\u041F\u0430\u043D\u043E\u0440\u0430\u043C\u0430",
        panorama_1: "\u041F\u0430\u043D\u043E\u0440\u0430\u043C\u044B",
        params: "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B",
        password: "\u041F\u0430\u0440\u043E\u043B\u044C",
        "plan perimeter": "\u041F\u043B\u0430\u043D\u043E\u0432\u044B\u0439 \u043F\u0435\u0440\u0438\u043C\u0435\u0442\u0440",
        perimeter: "\u041F\u0435\u0440\u0438\u043C\u0435\u0442\u0440",
        phone: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        photo_0: "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u044F",
        photo_1: "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438",
        pipelayer: "\u0422\u0440\u0443\u0431\u043E\u0443\u043A\u043B\u0430\u0434\u0447\u0438\u043A",
        "plan-fact analyze": "\u0410\u043D\u0430\u043B\u0438\u0437 '\u043F\u043B\u0430\u043D-\u0444\u0430\u043A\u0442'",
        "plan length": "\u041F\u043B\u0430\u043D\u043E\u0432\u0430\u044F \u0434\u043B\u0438\u043D\u0430",
        "point cloud": "\u041E\u0431\u043B\u0430\u043A\u043E \u0442\u043E\u0447\u0435\u043A",
        "points number": "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0442\u043E\u0447\u0435\u043A",
        "points size": "\u0420\u0430\u0437\u043C\u0435\u0440 \u0442\u043E\u0447\u0435\u043A",
        profile: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C",
        "profile width": "\u0428\u0438\u0440\u0438\u043D\u0430 \u043F\u0440\u043E\u0444\u0438\u043B\u044F",
        project: "\u041F\u0440\u043E\u0435\u043A\u0442",
        "ready for uploading": "\u0413\u043E\u0442\u043E\u0432\u043E \u0434\u043B\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438",
        remarks: "\u0417\u0430\u043C\u0435\u0447\u0430\u043D\u0438\u044F",
        recognition: "\u0420\u0430\u0441\u043F\u043E\u0437\u043D\u0430\u0432\u0430\u043D\u0438\u0435",
        "request error": "\u0423\u043F\u0441, \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u043F\u0440\u043E\u0441\u0435",
        "request success": "\u0412\u0430\u0448 \u0437\u0430\u043F\u0440\u043E\u0441 \u043F\u0440\u0438\u043D\u044F\u0442",
        "road roller": "\u041A\u0430\u0442\u043E\u043A",
        save: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
        "schedule control": "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u0441\u0440\u043E\u043A\u043E\u0432",
        search: "\u041F\u043E\u0438\u0441\u043A",
        "search area": "\u0417\u043E\u043D\u0430 \u043F\u043E\u0438\u0441\u043A\u0430",
        send: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
        september: "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        settings: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
        "show on map": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0430 \u043A\u0430\u0440\u0442\u0435",
        statistics: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430",
        submit: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
        "supported formats": "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u044B\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u044B",
        survey: "\u041E\u0431\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u044C",
        "survey request": "\u0417\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u0441\u044A\u0451\u043C\u043A\u0443",
        targets: "\u0421\u044A\u0451\u043C\u043A\u0438",
        "targets splitting by status": "\u0420\u0430\u0437\u0431\u0438\u0432\u043A\u0430 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043F\u043E \u0441\u0442\u0430\u0442\u0443\u0441\u0443",
        "targets quantity": "\u041A\u043E\u043B-\u0432\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432",
        tool_0: "\u0418\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
        tool_1: "\u0418\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u044B",
        "total percentage of targets readiness": "\u0421\u0443\u043C\u043C\u0430\u0440\u043D\u044B\u0439 \u043F\u0440\u043E\u0446\u0435\u043D\u0442 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432",
        tower: "\u0411\u0430\u0448\u043D\u044F",
        type: "\u0422\u0438\u043F",
        "upload file text": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u043E\u0431\u043B\u0430\u0441\u0442\u044C \u0438\u043B\u0438 \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B \u0441\u044E\u0434\u0430 \u0434\u043B\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438",
        "uploaded files": "\u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u0435 \u0444\u0430\u0439\u043B\u044B",
        user: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C",
        "user name": "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
        "very low": "\u041E\u0447\u0435\u043D\u044C \u043D\u0438\u0437\u043A\u043E\u0435",
        video_0: "\u0412\u0438\u0434\u0435\u043E",
        video_1: "\u0412\u0438\u0434\u0435\u043E",
        view: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
        volume: "\u041E\u0431\u044A\u0451\u043C",
        "volume 3D": "\u0417\u0430\u043C\u043A\u043D\u0443\u0442\u044B\u0439 \u043E\u0431\u044A\u0451\u043C",
        "volume above bp": "\u041E\u0431\u044A\u0451\u043C \u043D\u0430\u0434 \u0411\u041F",
        "volume below bp": "\u041E\u0431\u044A\u0451\u043C \u043F\u043E\u0434 \u0411\u041F",
        week: "\u041D\u0435\u0434\u0435\u043B\u044F",
        year: "\u0413\u043E\u0434",
        "profile label": "\u041F\u0440\u043E\u0444\u0438\u043B\u044C",
        "angle label": "\u0423\u0433\u043E\u043B",
        videoCamera_0: "\u0412\u0438\u0434\u0435\u043E\u043A\u0430\u043C\u0435\u0440\u0430",
        videoCamera_1: "\u0412\u0438\u0434\u0435\u043E\u043A\u0430\u043C\u0435\u0440\u044B",
        processes: "\u0420\u0430\u0431\u043E\u0447\u0438\u0435 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u044B",
        reviews: "\u0421\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
        premises: "\u041E\u0431\u044A\u0435\u043A\u0442\u044B",
        assets: "\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0438",
        logout: "\u0412\u044B\u0445\u043E\u0434 \u0438\u0437 \u0441\u0438\u0441\u0442\u0435\u043C\u044B",
        "loading administration platform": "\u0418\u0434\u0435\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043C\u043E\u0434\u0443\u043B\u044F \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B",
        "loading administration modules": "\u0418\u0434\u0435\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043C\u043E\u0434\u0443\u043B\u044F \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043C\u043E\u0434\u0443\u043B\u0435\u0439",
        "try again": "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
        "refresh without cache": "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0435\u0437 \u043A\u0435\u0448\u0430",
        "loading request module": "\u0418\u0434\u0435\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043C\u043E\u0434\u0443\u043B\u044F \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432",
        "you don't have a selected company": "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438",
        "You don't have an active company": "\u041D\u0435\u0442 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438",
        "No active company hint": "\u0412\u043E\u0439\u0434\u0438\u0442\u0435 \u043F\u043E\u0434 \u0434\u0440\u0443\u0433\u043E\u0439 \u0443\u0447\u0451\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u044C\u044E, \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0439 \u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438, \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443 \u0437\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u043E\u043C.",
        "Change the account": "\u0421\u043C\u0435\u043D\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
        "you don't have permission to view this module": "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u043D\u0430 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u043C\u043E\u0434\u0443\u043B\u044F",
        "loading assets module": "\u0418\u0434\u0435\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043C\u043E\u0434\u0443\u043B\u044F \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u043E\u0432",
        "An error has occurred": "\u0412\u043E\u0437\u043D\u0438\u043A\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
        "Try refreshing the application or contact us at": "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0438\u043B\u0438 \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438",
        "Copy error log": "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043B\u043E\u0433 \u043E\u0448\u0438\u0431\u043A\u0438",
        "Return to the main page": "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E",
        "Copied! \u2713": "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E! \u2713"
      }
    },
    "zh-CN": {
      translations: {
        settings: "\u8BBE\u7F6E",
        "administration modules": "\u6A21\u5757\u7BA1\u7406",
        "administration platform": "\u5E73\u53F0\u7BA1\u7406",
        "template constructor": "\u6A21\u677F\u6784\u9020\u5668",
        "admin panel": "\u7BA1\u7406\u9762\u677F",
        assets: "\u8D44\u4EA7",
        premises: "\u623F\u5C4B",
        logout: "\u9000\u51FA\u7CFB\u7EDF",
        "loading administration platform": "\u6B63\u5728\u52A0\u8F7D\u5E73\u53F0\u7BA1\u7406\u6A21\u5757",
        "loading administration modules": "\u6B63\u5728\u52A0\u8F7D\u6A21\u5757\u7BA1\u7406",
        "try again": "\u91CD\u8BD5",
        "refresh without cache": "\u5237\u65B0\u65E0\u7F13\u5B58",
        "loading request module": "\u52A0\u8F7D\u8BF7\u6C42\u6A21\u5757",
        "you don't have a selected company": "\u60A8\u6CA1\u6709\u9009\u62E9\u516C\u53F8",
        "You don't have an active company": "\u6CA1\u6709\u6D3B\u8DC3\u7684\u516C\u53F8",
        "No active company hint": "\u8BF7\u4F7F\u7528\u5DF2\u5173\u8054\u7EC4\u7EC7\u7684\u5176\u4ED6\u8D26\u53F7\u767B\u5F55\uFF0C\u6216\u8054\u7CFB\u7BA1\u7406\u5458\u83B7\u53D6\u8BBF\u95EE\u6743\u9650\u3002",
        "Change the account": "\u5207\u6362\u8D26\u53F7",
        "you don't have permission to view this module": "\u60A8\u6CA1\u6709\u6743\u9650\u67E5\u770B\u6B64\u6A21\u5757",
        "loading assets module": "\u52A0\u8F7D\u8D44\u4EA7\u6A21\u5757",
        "An error has occurred": "\u53D1\u751F\u9519\u8BEF",
        "Try refreshing the application or contact us at": "\u5C1D\u8BD5\u5237\u65B0\u5E94\u7528\u7A0B\u5E8F\u6216\u8054\u7CFB\u6211\u4EEC",
        "Copy error log": "\u590D\u5236\u9519\u8BEF\u65E5\u5FD7",
        "Return to the main page": "\u8FD4\u56DE\u4E3B\u9875",
        "Copied! \u2713": "\u590D\u5236\u6210\u529F! \u2713"
      }
    }
  },
  fallbackLng: "ru",
  debug: false,
  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",
  detection: {
    order: ["localStorage", "navigator", "htmlTag"],
    caches: ["localStorage"]
  },
  keySeparator: false,
  // we use content as keys
  interpolation: {
    format: (value, format) => {
      if (value instanceof Date) {
        return moment__WEBPACK_IMPORTED_MODULE_1___default()(value).format(format);
      }
      return value;
    },
    formatSeparator: ","
  },
  react: {
    wait: true
  },
  whitelist: ["ru", "en", "zh-CN"]
};
i18next__WEBPACK_IMPORTED_MODULE_0__/* ["default"].init */ .Ay.init(initObj);
i18next__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Ay.on("languageChanged", (lng) => {
  localStorage.setItem("language", lng);
  _modules_translator__WEBPACK_IMPORTED_MODULE_2__/* .translator */ .N.setLanguage(lng);
  moment__WEBPACK_IMPORTED_MODULE_1___default().locale(lng);
});
const language = localStorage.getItem("language");
if (language) {
  i18next__WEBPACK_IMPORTED_MODULE_0__/* ["default"].changeLanguage */ .Ay.changeLanguage(language);
}
/* harmony default export */ __webpack_exports__.A = (i18next__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Ay);


/***/ }),

/***/ 10830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports AppTypes, SchedulePeriods, ScheduleAction, getTargetMissions, getMissionVideos, getMissionOrthoPhotos, getMissionPointClouds, getMissionPanoramas, getMissionImages, getPointCloudsMeasurements */

const Url = {
  home: "/",
  analytics: "/analytics",
  targets: "/targets",
  workspaces: "/workspaces/:workspaceId",
  workspacesV2: "/workspaces-v2/:workspaceId",
  workflows: "/workflows",
  remarks: "/remarks",
  inspections: "/inspections",
  documentations: "/documentations",
  documentationsWithId: "/documentations/:id",
  templateConstructor: "/templates",
  templateConstructorFields: "/templates/fields",
  templateConstructorTemplates: "/templates/templates",
  templateConstructorTemplate: "/templates/templates/:id",
  stats: "/analytic",
  settings: "/preferences",
  projectsOverview: "/projects",
  asbuilt: "/asbuilt",
  management: "/management",
  managementValues: "/management/:type/:id",
  projects: "/analytics/metrics",
  metric: "/analytics/metrics/:metricId",
  tasks: "/management/projects",
  myTasks: "/management/myTasks",
  projectTemplates: "/management/project-templates",
  resourcePlanning: "/management/resource-planning",
  calendars: "/management/calendars",
  task: "/management/projects/:projectId",
  kanban: "/management/projects/:taskId/kanban",
  timeline: "/management/projects/:projectId/timeline",
  resource: "/management/projects/:projectId/resource-planning",
  expressions: "/analytics/expressions",
  attributes: "/analytics/attributes",
  attribute: "/analytics/attributes/:attributeId",
  dashboards: "/analytics/dashboards",
  dashboardsV2: "/analytics/dashboards-v2",
  dashboard: "/analytics/dashboards/:dashboardId",
  order: "/orders/:number",
  viewer: "/orders/:number/viewer/:pointCloudId",
  photogrammetry: "/orders/:number/photogrammetry",
  login: "/login",
  abap: "/orders/:number/abap/:filedId/",
  align: "/orders/:order/projects/:project/align",
  control: "/control",
  account: "/account",
  processes: "/processes",
  reviews: "/reviews",
  reviewsWorkload: "/reviews/workload",
  reviewsCurrentTasks: "/reviews/current-tasks",
  adminProc: "/admin-frontend",
  administration: "/administration",
  administrationUsers: "/administration/users",
  administrationAttributes: "/administration/attributes",
  administrationRoles: "/administration/roles",
  administrationDepartments: "/administration/departments",
  assets: "/assets",
  premises: "/premises",
  automation: "/automation",
  issues: "/issues",
  transmittal: "/transmittal",
  transmittalWithId: "/transmittal/:id",
  transmittalHistory: "/transmittal/:id/history",
  contracts: "/contracts",
  rfi: "/rfi",
  rfiWithId: "/rfi/:id",
  callback: "/auth/callback",
  error: "/auth/error",
  logout: "/auth/logout",
  prescriptions: "/prescriptions",
  wiki: "/wiki",
  sarexPulse: "/sarex-pulse",
  support: "/support"
};
const CVItems = {
  Vehicles: "vehicles",
  ContructionVehicles: "construction_vehicles",
  Piles: "piles",
  People: "people"
};
const MenuTabs = {
  PointCloud: 0,
  Elevation: 1,
  Orthophoto: 2,
  Docs: 3
};
const FileTypes = {
  Png: "png",
  Jpg: "jpg",
  Pdf: "pdf",
  Folder: "folder"
};
const AppTypes = (/* unused pure expression or super */ null && ({
  Bim: "bim",
  Main: "main"
}));
const ConstructionVehicleTypes = {
  DumpTruck: "\u0421\u0430\u043C\u043E\u0441\u0432\u0430\u043B",
  //"dump_truck",
  Bulldozer: "\u0411\u0443\u043B\u044C\u0434\u043E\u0437\u0435\u0440",
  //"bulldozer",
  Excavator: "\u042D\u043A\u0441\u043A\u0430\u0432\u0430\u0442\u043E\u0440",
  //"excavator",
  PipeLayer: "\u0422\u0440\u0443\u0431\u043E\u0443\u043A\u043B\u0430\u0434\u0447\u0438\u043A",
  //"pipelayer",
  Loader: "\u041F\u043E\u0433\u0440\u0443\u0437\u0447\u0438\u043A",
  //"loader",
  ConcreteMixer: "\u0411\u0435\u0442\u043E\u043D\u043E\u043C\u0435\u0448\u0430\u043B\u043A\u0430",
  //"concrete mixer",
  RoadRoller: "\u041A\u0430\u0442\u043E\u043A"
  //"road roller",
};
const Layers = {
  Cadastral: "cadastral",
  DigitalElemetionModel: "digitalElemetionModel",
  ZoneModel: "zoneModel",
  SearchArea: "searchArea",
  Orthophoto: "orthophoto",
  CV: {
    construction_vehicles: "__sarex-cv_construction-vehicles",
    vehicles: "__sarex-cv_vehicles",
    piles: "__sarex-cv_piles",
    people: "__sarex-cv_people"
  },
  Base: "base"
};
const ZoomLevels = {
  Default: 18,
  Max: 23
};
const ComparisonType = {
  Diff: 1,
  Ground: 2,
  Project: 3,
  Deviation: 4,
  Abap: 99,
  C2S: 5
};
const SchedulePeriods = (/* unused pure expression or super */ null && ({
  Day: 1,
  Week: 2,
  Month: 3,
  Year: 4
}));
const PotreeMeasurementsConfig = {
  Distance: {
    closed: false,
    name: "distance"
  },
  Area: {
    closed: true,
    showDistances: true,
    showArea: true,
    name: "area"
  },
  Polygon: {
    closed: true,
    showDistances: true,
    showArea: true,
    name: "polygon"
  },
  Volume: {
    closed: true,
    elevated: true,
    name: "volume",
    showArea: false,
    showDistances: false
  },
  Annotation: {
    closed: true,
    showDistances: false,
    showArea: false,
    showCoordinates: true,
    maxMarkers: 1,
    name: "point"
  },
  Profile: {
    name: "profile"
  },
  HeightLevel: {
    name: "heightLevel",
    maxMarkers: 1
  },
  SurfacePoints: {
    name: "surfacePoints",
    style: { linewidth: 0, dash: { size: 1 }, opacity: 0, fillAlpha: 0.15 },
    closed: false,
    showDistances: false,
    minimalPointsForDelete: 0,
    middlePointType: "hidden"
  }
};
const ScheduleAction = (/* unused pure expression or super */ null && ({
  Add: "add",
  Delete: "delete",
  Update: "update",
  AddLink: "addLink",
  DeleteLink: "deleteLink",
  UpdateLink: "updateLink",
  OpenTask: "open",
  CloseTask: "close"
}));
const NotificationTypes = {
  Loading: "loading",
  Loaded: "loaded",
  Processing: "processing",
  ProcessingStart: "processing start",
  Completed: "completed",
  Failed: "failed",
  Info: "info"
};
const CoordsSystems = {
  MSK50: "+proj=tmerc +lat_0=0 +lon_0=38.48333333333 +k=1 +x_0=2250000 +y_0=-5712900.566 +ellps=krass +towgs84=23.57,-140.95,-79.8,0,0.35,0.79,-0.22 +units=m +no_defs",
  WGS84: "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs"
};
const VolumeTypes = {
  fact: "fact",
  project: "project",
  baseplane: "baseplane"
};
const ResolutionTypes = {
  VeryLow: "very low",
  Low: "low",
  Middle: "middle",
  High: "high"
};
const Separators = [
  {
    label: "\u0422\u0430\u0431\u0443\u043B\u044F\u0446\u0438\u044F",
    value: "	",
    id: 1
  },
  {
    label: "\u041F\u0440\u043E\u0431\u0435\u043B",
    value: " ",
    id: 2
  },
  {
    label: "\u0417\u0430\u043F\u044F\u0442\u0430\u044F",
    value: ",",
    id: 3
  },
  {
    label: "\u0422\u043E\u0447\u043A\u0430 \u0441 \u0437\u0430\u043F\u044F\u0442\u043E\u0439",
    value: ";",
    id: 4
  }
];
const ResolutionTypesServerKeys = {
  [ResolutionTypes.VeryLow]: 1,
  [ResolutionTypes.Low]: 2,
  [ResolutionTypes.Middle]: 3,
  [ResolutionTypes.High]: 4
};
const ProjectStatus = {
  NotInit: "not_initialized",
  Creation: "project_creation",
  PhotosMatching: "photos_matching",
  Alignment: "alignment",
  MarkersAnalysis: "markers_analysis",
  AlignCompleted: "init_complete",
  DepthMaps: "depth_maps",
  DepthMapsCompleted: "depth_maps_completed",
  DenseCloud: "dense_cloud",
  DenseCloudCompleted: "dense_cloud_completed",
  Complete: "complete",
  Export: "export",
  ExportCompleted: "export_completed",
  Failed: "failed"
};
const FiltrationTypes = {
  Aggressive: "aggressive",
  Moderate: "moderate"
};
const FiltrationTypesServerKeys = {
  [FiltrationTypes.Aggressive]: 1,
  [FiltrationTypes.Moderate]: 2
};
const maxPointsNumber = 1e8;
const defaultPointsNumber = 4e7;
const getTargetMissions = (target) => target.missions || [];
const getMissionVideos = (mission) => mission.videos || [];
const getMissionOrthoPhotos = (mission) => mission.orthophotos || [];
const getMissionPointClouds = (mission) => mission.pointclouds || [];
const getMissionPanoramas = (mission) => mission.panoramas || [];
const getMissionImages = (mission) => mission.images || [];
const getPointCloudsMeasurements = (pointClouds) => pointClouds && pointClouds.length > 0 ? pointClouds.map((pointCloud) => pointCloud.measurements) : [];
const TYPE_DOCUMENTS = {
  tilesPdf: "tilesPdf",
  projectModels: "projectModels"
};

/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "$d", 0, /* binding */ ConstructionVehicleTypes,
/* harmony export */   "Ks", 0, /* binding */ ProjectStatus,
/* harmony export */   "LR", 0, /* binding */ Separators,
/* harmony export */   "Md", 0, /* binding */ TYPE_DOCUMENTS,
/* harmony export */   "UL", 0, /* binding */ FiltrationTypes,
/* harmony export */   "VL", 0, /* binding */ NotificationTypes,
/* harmony export */   "Xp", 0, /* binding */ ZoomLevels,
/* harmony export */   "_C", 0, /* binding */ defaultPointsNumber,
/* harmony export */   "_z", 0, /* binding */ MenuTabs,
/* harmony export */   "a0", 0, /* binding */ FileTypes,
/* harmony export */   "bQ", 0, /* binding */ ResolutionTypesServerKeys,
/* harmony export */   "ei", 0, /* binding */ ResolutionTypes,
/* harmony export */   "g1", 0, /* binding */ ComparisonType,
/* harmony export */   "kb", 0, /* binding */ CVItems,
/* harmony export */   "ni", 0, /* binding */ PotreeMeasurementsConfig,
/* harmony export */   "ro", 0, /* binding */ FiltrationTypesServerKeys,
/* harmony export */   "s0", 0, /* binding */ Url,
/* harmony export */   "tF", 0, /* binding */ maxPointsNumber,
/* harmony export */   "wD", 0, /* binding */ VolumeTypes,
/* harmony export */   "xr", 0, /* binding */ CoordsSystems,
/* harmony export */   "zg", 0, /* binding */ Layers
/* harmony export */ ]);


/***/ }),

/***/ 74178:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(54914);
// EXTERNAL MODULE: ./node_modules/@sentry/react/build/esm/sdk.js + 1 modules
var sdk = __webpack_require__(56220);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/breadcrumbs.js + 1 modules
var breadcrumbs = __webpack_require__(85148);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/tracing/browserTracingIntegration.js + 3 modules
var browserTracingIntegration = __webpack_require__(22518);
// EXTERNAL MODULE: ./node_modules/@sentry/replay/build/npm/esm/index.js + 1 modules
var esm = __webpack_require__(58779);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/browserapierrors.js
var browserapierrors = __webpack_require__(19647);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: consume shared module (default) react-dom@=17.0.2 (singleton) (fallback: ./node_modules/react-dom/index.js) (eager)
var react_dom_index_js_eager_ = __webpack_require__(51971);
// EXTERNAL MODULE: consume shared module (default) @sarex-team/srx-pdf-runtime@=2.0.1 (singleton) (fallback: ./node_modules/@sarex-team/srx-pdf-runtime/dist/index.js) (eager)
var dist_index_js_eager_ = __webpack_require__(63495);
;// ./src/initPdf.ts


const initPdf = async () => {
  const config = {
    workerVersion: "2.0.1",
    baseUrl: new URL("/static/pdf-runtime/", location.href).toString(),
    assetsRoute: "/assets"
  };
  try {
    await (0,dist_index_js_eager_.checkAssetIsValid)(config, true);
    (0,dist_index_js_eager_.configureSharedPdfRuntime)(config);
    console.debug("[PDF Runtime init]", config);
  } catch (e) {
    console.error("[PDF runtime] Error:", e);
  }
};

// EXTERNAL MODULE: ./src/Model/i18n.js
var i18n = __webpack_require__(44442);
// EXTERNAL MODULE: ./src/shared/config/config.ts
var config = __webpack_require__(82448);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(85072);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(97825);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(77659);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(55056);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(10540);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(41113);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[5].use[2]!./src/style.scss
var style = __webpack_require__(50215);
;// ./src/style.scss

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());
options.insert = insertBySelector_default().bind(null, "head");
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(style/* default */.A, options);




       /* harmony default export */ var src_style = (style/* default */.A && style/* default */.A.locals ? style/* default */.A.locals : undefined);

// EXTERNAL MODULE: ./src/Model/storeLegacy.js
var storeLegacy = __webpack_require__(10830);
;// ./src/index.jsx











const AUTH_FLOW_PAGES = {
  AUTH_CALLBACK_PAGE: storeLegacy/* Url */.s0.callback,
  AUTH_ERROR_PAGE: storeLegacy/* Url */.s0.error
};
class src_URL extends window.URL {
  constructor(a, b) {
    if (b === "" || b === "/") b = window.location.origin;
    super(a, b);
  }
}
window.URL = src_URL;
if (typeof window !== "undefined" && "false" === "true") // removed by dead control flow
{}
const SENTRY_RELEASE = "stage-1793727479" || 0;
if ( true && !window.disableSentry) {
  sdk/* init */.T({
    dsn: "https://a064fc3e223bcde90f8d638e948d3415@sentry.sarex.io/12",
    environment: "stage" || 0,
    release: SENTRY_RELEASE,
    // Отключаем контекст
    attachStacktrace: false,
    sendDefaultPii: false,
    // Разумное количество breadcrumbs для отладки
    maxBreadcrumbs: 50,
    normalizeDepth: 3,
    integrations: (defaults) => [
      // Убираем CaptureConsole - создает обертки в консоли
      ...defaults.filter((i) => i.name !== "CaptureConsole"),
      breadcrumbs/* breadcrumbsIntegration */.F({ console: false }),
      browserTracingIntegration/* browserTracingIntegration */.dp(),
      esm/* replayIntegration */.w({
        maskAllInputs: true,
        maskAllText: true,
        blockAllMedia: true
      }),
      browserapierrors/* browserApiErrorsIntegration */.G({
        requestAnimationFrame: false,
        setTimeout: false,
        setInterval: false
      })
    ],
    tracesSampleRate:  false ? 0 : 1,
    replaysSessionSampleRate:  false ? 0 : 0.1,
    replaysOnErrorSampleRate:  false ? 0 : 1,
    denyUrls: [/\/static\/sarex-viewer\//],
    beforeSend(event, hint) {
      const maskPathIds = (urlString) => {
        try {
          const u = new src_URL(urlString);
          const uuid = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
          const hex24 = /^[0-9a-fA-F]{24}$/;
          const numId = /^\d{3,}$/;
          u.pathname = u.pathname.split("/").map(
            (seg) => uuid.test(seg) ? ":uuid" : hex24.test(seg) ? ":oid" : numId.test(seg) ? ":id" : seg
          ).join("/");
          return u.toString();
        } catch (_) {
          return urlString;
        }
      };
      if (event.request?.url) {
        event.request.url = maskPathIds(event.request.url);
      }
      if (event.exception) {
        const error = hint.originalException;
        if (error && error.message) {
          const ignoredMessages = [
            "Non-Error promise rejection",
            "Network Error",
            "ChunkLoadError",
            "Loading chunk",
            "ResizeObserver loop limit exceeded",
            "Script error",
            "NetworkError when attempting to fetch resource",
            "The request is not allowed by the user agent",
            "AbortError",
            "SecurityError",
            "Top-level await is only supported"
          ];
          if (ignoredMessages.some((msg) => error.message.includes(msg))) {
            return null;
          }
        }
      }
      if (event.request?.url) {
        const ignoredUrls = [
          "/sockjs-node/",
          "/hot-update",
          "chrome-extension://",
          "moz-extension://",
          "webpack-internal://"
        ];
        if (ignoredUrls.some((url) => event.request.url.includes(url))) {
          return null;
        }
      }
      return event;
    },
    initialScope: {
      tags: {
        endpoint: "stage" || 0
      }
    }
  });
}
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}
const isAuthFlowPage = () => {
  const p = window.location.pathname.replace(/\/$/, "") || "/";
  return Object.values(AUTH_FLOW_PAGES).includes(p);
};
const renderAuthFlowPage = async () => {
  const { AuthCallbackPage } = await Promise.all(/* import() */[__webpack_require__.e(780), __webpack_require__.e(40), __webpack_require__.e(154)]).then(__webpack_require__.bind(__webpack_require__, 67154));
  const { AuthErrorPage } = await __webpack_require__.e(/* import() */ 892).then(__webpack_require__.bind(__webpack_require__, 10892));
  if (window.location.pathname.includes(AUTH_FLOW_PAGES.AUTH_CALLBACK_PAGE)) {
    react_dom_index_js_eager_.render(/* @__PURE__ */ (0,jsx_runtime.jsx)(AuthCallbackPage, {}), document.getElementById("root"));
  } else if (window.location.pathname.includes(AUTH_FLOW_PAGES.AUTH_ERROR_PAGE)) {
    react_dom_index_js_eager_.render(/* @__PURE__ */ (0,jsx_runtime.jsx)(AuthErrorPage, {}), document.getElementById("root"));
  }
};
const renderApp = async () => {
  await config/* config */.$.load();
  const RootModule = await Promise.all(/* import() */[__webpack_require__.e(780), __webpack_require__.e(113), __webpack_require__.e(395), __webpack_require__.e(40), __webpack_require__.e(663)]).then(__webpack_require__.bind(__webpack_require__, 38867));
  react_dom_index_js_eager_.render(/* @__PURE__ */ (0,jsx_runtime.jsx)(RootModule.default, {}), document.getElementById("root"));
};
if (isAuthFlowPage()) {
  renderAuthFlowPage();
} else {
  renderApp();
}
if (false) // removed by dead control flow
{}
initPdf();


/***/ }),

/***/ 34678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  T: function() { return /* reexport */ translate; },
  N: function() { return /* reexport */ translator; }
});

// EXTERNAL MODULE: consume shared module (default) @sarex-team/translator@=1.1.0 (singleton) (fallback: ./node_modules/@sarex-team/translator/dist/index.js) (eager)
var index_js_eager_ = __webpack_require__(97798);
;// ./modules/translator/translator.ts


const translator = index_js_eager_.globalTranslator;
translator.importLanguage("en", () => __webpack_require__.e(/* import() */ 189).then(__webpack_require__.t.bind(__webpack_require__, 46189, 23)));
translator.importLanguage("zh-CN", () => __webpack_require__.e(/* import() */ 514).then(__webpack_require__.t.bind(__webpack_require__, 50514, 23)));
console.log(translator);
const translate = translator.translate;

;// ./modules/translator/index.ts




/***/ }),

/***/ 82448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Config */

class Config {
  constructor() {
    this.data = null;
    this.cacheData = null;
    this.fileData = null;
    this.loaded = false;
    this.cacheKey = "config";
  }
  async load() {
    try {
      this.loadCache();
      if (this.cacheData) {
        this.data = this.cacheData;
        this.invalidateCache();
      } else {
        await this.loadFileData();
        this.data = this.fileData;
        this.setCache();
      }
    } catch (error) {
      console.error(error);
    }
    this.loaded = true;
  }
  async invalidateCache() {
    try {
      await this.loadFileData();
      if (JSON.stringify(this.fileData) !== JSON.stringify(this.cacheData)) {
        this.data = this.fileData;
        this.setCache();
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    }
  }
  async loadFileData() {
    try {
      const response = await fetch("/static/config.json");
      if (!response.ok) {
        throw new Error(`Config file is not found`);
      }
      const contentType = response.headers.get("content-type") || "";
      if (!contentType.includes("application/json")) {
        throw new Error(`Config file has invalid content-type: ${contentType}`);
      }
      const data = await response.json();
      this.fileData = data;
    } catch (error) {
    }
  }
  setCache() {
    try {
      localStorage.setItem(this.cacheKey, JSON.stringify(this.data));
    } catch (error) {
      console.error(error);
    }
  }
  loadCache() {
    try {
      const cache = localStorage.getItem(this.cacheKey);
      if (cache) {
        this.cacheData = JSON.parse(cache);
      }
    } catch (error) {
      console.error(error);
    }
  }
}
const config = new Config();

/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "$", 0, /* binding */ config
/* harmony export */ ]);


/***/ }),

/***/ 35358:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./af": 50247,
	"./af.js": 50247,
	"./ar": 80627,
	"./ar-dz": 68118,
	"./ar-dz.js": 68118,
	"./ar-kw": 15302,
	"./ar-kw.js": 15302,
	"./ar-ly": 80891,
	"./ar-ly.js": 80891,
	"./ar-ma": 18,
	"./ar-ma.js": 18,
	"./ar-ps": 9129,
	"./ar-ps.js": 9129,
	"./ar-sa": 74712,
	"./ar-sa.js": 74712,
	"./ar-tn": 54058,
	"./ar-tn.js": 54058,
	"./ar.js": 80627,
	"./az": 91611,
	"./az.js": 91611,
	"./be": 2269,
	"./be.js": 2269,
	"./bg": 22011,
	"./bg.js": 22011,
	"./bm": 42869,
	"./bm.js": 42869,
	"./bn": 61292,
	"./bn-bd": 56463,
	"./bn-bd.js": 56463,
	"./bn.js": 61292,
	"./bo": 11027,
	"./bo.js": 11027,
	"./br": 75800,
	"./br.js": 75800,
	"./bs": 10159,
	"./bs.js": 10159,
	"./ca": 56376,
	"./ca.js": 56376,
	"./cs": 14610,
	"./cs.js": 14610,
	"./cv": 18589,
	"./cv.js": 18589,
	"./cy": 83808,
	"./cy.js": 83808,
	"./da": 923,
	"./da.js": 923,
	"./de": 3391,
	"./de-at": 17149,
	"./de-at.js": 17149,
	"./de-ch": 33283,
	"./de-ch.js": 33283,
	"./de.js": 3391,
	"./dv": 75746,
	"./dv.js": 75746,
	"./el": 60317,
	"./el.js": 60317,
	"./en-au": 52610,
	"./en-au.js": 52610,
	"./en-ca": 56656,
	"./en-ca.js": 56656,
	"./en-gb": 54861,
	"./en-gb.js": 54861,
	"./en-ie": 15642,
	"./en-ie.js": 15642,
	"./en-il": 11441,
	"./en-il.js": 11441,
	"./en-in": 83567,
	"./en-in.js": 83567,
	"./en-nz": 20532,
	"./en-nz.js": 20532,
	"./en-sg": 2518,
	"./en-sg.js": 2518,
	"./eo": 48468,
	"./eo.js": 48468,
	"./es": 50128,
	"./es-do": 78420,
	"./es-do.js": 78420,
	"./es-mx": 25604,
	"./es-mx.js": 25604,
	"./es-us": 48605,
	"./es-us.js": 48605,
	"./es.js": 50128,
	"./et": 22341,
	"./et.js": 22341,
	"./eu": 54598,
	"./eu.js": 54598,
	"./fa": 46117,
	"./fa.js": 46117,
	"./fi": 80141,
	"./fi.js": 80141,
	"./fil": 66469,
	"./fil.js": 66469,
	"./fo": 8335,
	"./fo.js": 8335,
	"./fr": 85644,
	"./fr-ca": 63677,
	"./fr-ca.js": 63677,
	"./fr-ch": 95318,
	"./fr-ch.js": 95318,
	"./fr.js": 85644,
	"./fy": 84093,
	"./fy.js": 84093,
	"./ga": 32396,
	"./ga.js": 32396,
	"./gd": 37367,
	"./gd.js": 37367,
	"./gl": 11423,
	"./gl.js": 11423,
	"./gom-deva": 27322,
	"./gom-deva.js": 27322,
	"./gom-latn": 89285,
	"./gom-latn.js": 89285,
	"./gu": 26544,
	"./gu.js": 26544,
	"./he": 90123,
	"./he.js": 90123,
	"./hi": 63079,
	"./hi.js": 63079,
	"./hr": 57586,
	"./hr.js": 57586,
	"./hu": 4443,
	"./hu.js": 4443,
	"./hy-am": 91662,
	"./hy-am.js": 91662,
	"./id": 71969,
	"./id.js": 71969,
	"./is": 21252,
	"./is.js": 21252,
	"./it": 44977,
	"./it-ch": 80237,
	"./it-ch.js": 80237,
	"./it.js": 44977,
	"./ja": 7641,
	"./ja.js": 7641,
	"./jv": 63196,
	"./jv.js": 63196,
	"./ka": 16208,
	"./ka.js": 16208,
	"./kk": 4738,
	"./kk.js": 4738,
	"./km": 3223,
	"./km.js": 3223,
	"./kn": 50189,
	"./kn.js": 50189,
	"./ko": 89486,
	"./ko.js": 89486,
	"./ku": 27948,
	"./ku-kmr": 80235,
	"./ku-kmr.js": 80235,
	"./ku.js": 27948,
	"./ky": 23400,
	"./ky.js": 23400,
	"./lb": 4790,
	"./lb.js": 4790,
	"./lo": 88897,
	"./lo.js": 88897,
	"./lt": 62960,
	"./lt.js": 62960,
	"./lv": 83386,
	"./lv.js": 83386,
	"./me": 60014,
	"./me.js": 60014,
	"./mi": 72474,
	"./mi.js": 72474,
	"./mk": 92624,
	"./mk.js": 92624,
	"./ml": 58949,
	"./ml.js": 58949,
	"./mn": 49987,
	"./mn.js": 49987,
	"./mr": 77503,
	"./mr.js": 77503,
	"./ms": 82536,
	"./ms-my": 60195,
	"./ms-my.js": 60195,
	"./ms.js": 82536,
	"./mt": 96925,
	"./mt.js": 96925,
	"./my": 26186,
	"./my.js": 26186,
	"./nb": 29204,
	"./nb.js": 29204,
	"./ne": 43073,
	"./ne.js": 43073,
	"./nl": 56586,
	"./nl-be": 58734,
	"./nl-be.js": 58734,
	"./nl.js": 56586,
	"./nn": 92544,
	"./nn.js": 92544,
	"./oc-lnc": 26828,
	"./oc-lnc.js": 26828,
	"./pa-in": 13891,
	"./pa-in.js": 13891,
	"./pl": 62020,
	"./pl.js": 62020,
	"./pt": 72876,
	"./pt-br": 25277,
	"./pt-br.js": 25277,
	"./pt.js": 72876,
	"./ro": 26979,
	"./ro.js": 26979,
	"./ru": 55581,
	"./ru.js": 55581,
	"./sd": 22075,
	"./sd.js": 22075,
	"./se": 74132,
	"./se.js": 74132,
	"./si": 2784,
	"./si.js": 2784,
	"./sk": 33578,
	"./sk.js": 33578,
	"./sl": 87795,
	"./sl.js": 87795,
	"./sq": 52568,
	"./sq.js": 52568,
	"./sr": 32209,
	"./sr-cyrl": 52016,
	"./sr-cyrl.js": 52016,
	"./sr.js": 32209,
	"./ss": 64322,
	"./ss.js": 64322,
	"./sv": 93421,
	"./sv.js": 93421,
	"./sw": 49070,
	"./sw.js": 49070,
	"./ta": 79947,
	"./ta.js": 79947,
	"./te": 33999,
	"./te.js": 33999,
	"./tet": 72467,
	"./tet.js": 72467,
	"./tg": 4401,
	"./tg.js": 4401,
	"./th": 64828,
	"./th.js": 64828,
	"./tk": 71781,
	"./tk.js": 71781,
	"./tl-ph": 54877,
	"./tl-ph.js": 54877,
	"./tlh": 97546,
	"./tlh.js": 97546,
	"./tr": 99838,
	"./tr.js": 99838,
	"./tzl": 33360,
	"./tzl.js": 33360,
	"./tzm": 57511,
	"./tzm-latn": 96977,
	"./tzm-latn.js": 96977,
	"./tzm.js": 57511,
	"./ug-cn": 41360,
	"./ug-cn.js": 41360,
	"./uk": 37144,
	"./uk.js": 37144,
	"./ur": 53783,
	"./ur.js": 53783,
	"./uz": 59647,
	"./uz-latn": 76937,
	"./uz-latn.js": 76937,
	"./uz.js": 59647,
	"./vi": 94013,
	"./vi.js": 94013,
	"./x-pseudo": 32525,
	"./x-pseudo.js": 32525,
	"./yo": 41872,
	"./yo.js": 41872,
	"./zh-cn": 10074,
	"./zh-cn.js": 10074,
	"./zh-hk": 99094,
	"./zh-hk.js": 99094,
	"./zh-mo": 13323,
	"./zh-mo.js": 13323,
	"./zh-tw": 24542,
	"./zh-tw.js": 24542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35358;

/***/ }),

/***/ 63340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "b8a64e8a9d20c77e293b.png";

/***/ }),

/***/ 80533:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "fe2c1e58e4fb8ee9ef9e.woff";

/***/ }),

/***/ 31725:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "bf3a9ac0d09d3371255c.woff2";

/***/ }),

/***/ 97274:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "584e723c567508ba905c.woff";

/***/ }),

/***/ 21036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "03418c694432320d7ebd.woff2";

/***/ }),

/***/ 63498:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "23d06b80ce88b0434267.woff";

/***/ }),

/***/ 81365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "3d51b4bfad0ba3d9c9c4.woff";

/***/ }),

/***/ 57421:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "25d8fb407c01c42b3911.woff2";

/***/ }),

/***/ 82938:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "3e5fd96cbaa2dd02e9ba.woff";

/***/ }),

/***/ 92556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "ac4c10943c910c5340f5.woff2";

/***/ }),

/***/ 37939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "1229ad96b77246ca80d4.otf";

/***/ }),

/***/ 96140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "233a619a8fe7cddb1d7e.otf";

/***/ }),

/***/ 56107:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "3799cddf3883dcc94716.otf";

/***/ }),

/***/ 49107:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "1f1a7f92505ed532c26c.otf";

/***/ }),

/***/ 21060:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "f5c42b34a46f693e3444.otf";

/***/ }),

/***/ 3284:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = __webpack_require__.p + "2145bbd21ef42fc98a10.png";

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = __webpack_module_cache__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd options */
/******/ 	!function() {
/******/ 		__webpack_require__.amdO = {};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	!function() {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = function(result, chunkIds, fn, priority) {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every(function(key) { return __webpack_require__.O[key](chunkIds[j]); })) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	!function() {
/******/ 		var getProto = Object.getPrototypeOf ? function(obj) { return Object.getPrototypeOf(obj); } : function(obj) { return obj.__proto__; };
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; (typeof current == 'object' || typeof current == 'function') && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach(function(key) { def[key] = function() { return value[key]; }; });
/******/ 			}
/******/ 			def['default'] = function() { return value; };
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter/value functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			if(Array.isArray(definition)) {
/******/ 				var i = 0;
/******/ 				while(i < definition.length) {
/******/ 					var key = definition[i++];
/******/ 					var binding = definition[i++];
/******/ 					if(!__webpack_require__.o(exports, key)) {
/******/ 						if(binding === 0) {
/******/ 							Object.defineProperty(exports, key, { enumerable: true, value: definition[i++] });
/******/ 						} else {
/******/ 							Object.defineProperty(exports, key, { enumerable: true, get: binding });
/******/ 						}
/******/ 					} else if(binding === 0) { i++; }
/******/ 				}
/******/ 			} else {
/******/ 				for(var key in definition) {
/******/ 					if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 						Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	!function() {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = function(chunkId) {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce(function(promises, key) {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return "" + {"3":"2d3912147d0e748ae74e","4":"72d3cf9c6b8420920083","113":"96f6273e590214f46a6d","154":"f8bd658c99ff6bdb3b8c","189":"e9139d7907f8f256d03b","196":"139c42eca42f20be068b","232":"95fc861dc988f183bc1f","246":"892263bcd082834f092e","267":"a8bc109a91fa68c6454d","368":"eeedeaaa82becd8d7afc","392":"ad2d1543561d627edebb","395":"e680985c3f98192130b2","493":"d155b1386c44cefdcddb","514":"71156dcba814362e85b4","593":"70578a91f2d7f1d070f4","607":"652e0e46fb93c71ab1a4","634":"82d19c21d901663061ff","663":"3f699ebdadae1c89eeb4","780":"24f83b665f9702d6be31","873":"9a911d7eaeb8042ea6b5","892":"8ab4c255d458c92bfcfe","933":"3e3c150fb98f2ac8160e","954":"39932735482a1eabb37d","958":"c605fdf3eeea7539e32d","975":"cfb613cca25ef979ed1c","983":"c795a956334cc3dc9fbe"}[chunkId] + ".bundle.js";
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.hmd = function(module) {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: function() {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	!function() {
/******/ 		var inProgress = {};
/******/ 		// data-webpack is not used as build has no uniqueName
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = function(url, done, key, chunkId) {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 		
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = function(prev, event) {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach(function(fn) { return fn(event); });
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/set anonymous default export name */
/******/ 	!function() {
/******/ 		// set .name for anonymous default exports per ES spec
/******/ 		__webpack_require__.dn = function(x) {
/******/ 			(Object.getOwnPropertyDescriptor(x, "name") || {}).writable || Object.defineProperty(x, "name", { value: "default", configurable: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/sharing */
/******/ 	!function() {
/******/ 		__webpack_require__.S = {};
/******/ 		var initPromises = {};
/******/ 		var initTokens = {};
/******/ 		__webpack_require__.I = function(name, initScope) {
/******/ 			if(!initScope) initScope = [];
/******/ 			// handling circular init calls
/******/ 			var initToken = initTokens[name];
/******/ 			if(!initToken) initToken = initTokens[name] = {};
/******/ 			if(initScope.indexOf(initToken) >= 0) return;
/******/ 			initScope.push(initToken);
/******/ 			// only runs once
/******/ 			if(initPromises[name]) return initPromises[name];
/******/ 			// creates a new share scope if needed
/******/ 			if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
/******/ 			// runs all init snippets from all modules reachable
/******/ 			var scope = __webpack_require__.S[name];
/******/ 			var warn = function(msg) {
/******/ 				if (typeof console !== "undefined" && console.warn) console.warn(msg);
/******/ 			};
/******/ 			var uniqueName = undefined;
/******/ 			var register = function(name, version, factory, eager) {
/******/ 				var versions = scope[name] = scope[name] || {};
/******/ 				var activeVersion = versions[version];
/******/ 				if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
/******/ 			};
/******/ 			var initExternal = function(id) {
/******/ 				var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
/******/ 				try {
/******/ 					var module = __webpack_require__(id);
/******/ 					if(!module) return;
/******/ 					var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
/******/ 					if(module.then) return promises.push(module.then(initFn, handleError));
/******/ 					var initResult = initFn(module);
/******/ 					if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
/******/ 				} catch(err) { handleError(err); }
/******/ 			}
/******/ 			var promises = [];
/******/ 			switch(name) {
/******/ 				case "default": {
/******/ 					register("@material-ui/core", "4.12.4", function() { return function() { return __webpack_require__(98227); }; }, 1);
/******/ 					register("@sarex-team/sdk-js", "0.3.72", function() { return function() { return __webpack_require__(25472); }; }, 1);
/******/ 					register("@sarex-team/srx-pdf-runtime", "2.0.1", function() { return function() { return __webpack_require__(73370); }; }, 1);
/******/ 					register("@sarex-team/srx-ui-kit", "0.8.10", function() { return Promise.all([__webpack_require__.e(493), __webpack_require__.e(113)]).then(function() { return function() { return __webpack_require__(94493); }; }); });
/******/ 					register("@sarex-team/translator", "1.1.0", function() { return function() { return __webpack_require__(95562); }; }, 1);
/******/ 					register("@sarex-team/ui-kit", "2.0.31", function() { return function() { return __webpack_require__(42689); }; }, 1);
/******/ 					register("L2DV", "1.9.4", function() { return function() { return __webpack_require__(32939); }; }, 1);
/******/ 					register("mobx-react-lite", "3.4.3", function() { return function() { return __webpack_require__(3707); }; }, 1);
/******/ 					register("mobx", "6.9.0", function() { return function() { return __webpack_require__(48235); }; }, 1);
/******/ 					register("react-dom", "17.0.2", function() { return function() { return __webpack_require__(13499); }; }, 1);
/******/ 					register("react-router-dom", "5.3.4", function() { return function() { return __webpack_require__(57847); }; }, 1);
/******/ 					register("react", "17.0.2", function() { return function() { return __webpack_require__(17866); }; }, 1);
/******/ 				}
/******/ 				break;
/******/ 			}
/******/ 			if(!promises.length) return initPromises[name] = 1;
/******/ 			return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "/static/";
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/consumes */
/******/ 	!function() {
/******/ 		var parseVersion = function(str) {
/******/ 			// see webpack/lib/util/semver.js for original code
/******/ 			var p=function(p){return p.split(".").map(function(p){return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
/******/ 		}
/******/ 		var versionLt = function(a, b) {
/******/ 			// see webpack/lib/util/semver.js for original code
/******/ 			a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
/******/ 		}
/******/ 		var rangeToString = function(range) {
/******/ 			// see webpack/lib/util/semver.js for original code
/******/ 			var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
/******/ 		}
/******/ 		var satisfy = function(range, version) {
/******/ 			// see webpack/lib/util/semver.js for original code
/******/ 			if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
/******/ 		}
/******/ 		var exists = function(scope, key) {
/******/ 			return scope && __webpack_require__.o(scope, key);
/******/ 		}
/******/ 		var get = function(entry) {
/******/ 			entry.loaded = 1;
/******/ 			return entry.get()
/******/ 		};
/******/ 		var eagerOnly = function(versions) {
/******/ 			return Object.keys(versions).reduce(function(filtered, version) {
/******/ 					if (versions[version].eager) {
/******/ 						filtered[version] = versions[version];
/******/ 					}
/******/ 					return filtered;
/******/ 			}, {});
/******/ 		};
/******/ 		var findLatestVersion = function(scope, key, eager) {
/******/ 			var versions = eager ? eagerOnly(scope[key]) : scope[key];
/******/ 			var key = Object.keys(versions).reduce(function(a, b) {
/******/ 				return !a || versionLt(a, b) ? b : a;
/******/ 			}, 0);
/******/ 			return key && versions[key];
/******/ 		};
/******/ 		var findSatisfyingVersion = function(scope, key, requiredVersion, eager) {
/******/ 			var versions = eager ? eagerOnly(scope[key]) : scope[key];
/******/ 			var key = Object.keys(versions).reduce(function(a, b) {
/******/ 				if (!satisfy(requiredVersion, b)) return a;
/******/ 				return !a || versionLt(a, b) ? b : a;
/******/ 			}, 0);
/******/ 			return key && versions[key]
/******/ 		};
/******/ 		var findSingletonVersionKey = function(scope, key, eager) {
/******/ 			var versions = eager ? eagerOnly(scope[key]) : scope[key];
/******/ 			return Object.keys(versions).reduce(function(a, b) {
/******/ 				return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
/******/ 			}, 0);
/******/ 		};
/******/ 		var getInvalidSingletonVersionMessage = function(scope, key, version, requiredVersion) {
/******/ 			return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
/******/ 		};
/******/ 		var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion, eager) {
/******/ 			var versions = scope[key];
/******/ 			return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
/******/ 				"Available versions: " + Object.keys(versions).map(function(key) {
/******/ 				return key + " from " + versions[key].from;
/******/ 			}).join(", ");
/******/ 		};
/******/ 		var fail = function(msg) {
/******/ 			throw new Error(msg);
/******/ 		}
/******/ 		var failAsNotExist = function(scopeName, key) {
/******/ 			return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
/******/ 		}
/******/ 		var warn = /*#__PURE__*/ function(msg) {
/******/ 			if (typeof console !== "undefined" && console.warn) console.warn(msg);
/******/ 		};
/******/ 		var init = function(fn) { return function(scopeName, key, eager, c, d) {
/******/ 			var promise = __webpack_require__.I(scopeName);
/******/ 			if (promise && promise.then && !eager) {
/******/ 				return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
/******/ 			}
/******/ 			return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
/******/ 		}; };
/******/ 		
/******/ 		var useFallback = function(scopeName, key, fallback) {
/******/ 			return fallback ? fallback() : failAsNotExist(scopeName, key);
/******/ 		}
/******/ 		var load = /*#__PURE__*/ init(function(scopeName, scope, key, eager, fallback) {
/******/ 			if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
/******/ 			return get(findLatestVersion(scope, key, eager));
/******/ 		});
/******/ 		var loadVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
/******/ 			if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
/******/ 			var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
/******/ 			if (satisfyingVersion) return get(satisfyingVersion);
/******/ 			warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
/******/ 			return get(findLatestVersion(scope, key, eager));
/******/ 		});
/******/ 		var loadStrictVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
/******/ 			if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
/******/ 			var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
/******/ 			if (satisfyingVersion) return get(satisfyingVersion);
/******/ 			if (fallback) return fallback();
/******/ 			fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
/******/ 		});
/******/ 		var loadSingleton = /*#__PURE__*/ init(function(scopeName, scope, key, eager, fallback) {
/******/ 			if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
/******/ 			var version = findSingletonVersionKey(scope, key, eager);
/******/ 			return get(scope[key][version]);
/******/ 		});
/******/ 		var loadSingletonVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
/******/ 			if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
/******/ 			var version = findSingletonVersionKey(scope, key, eager);
/******/ 			if (!satisfy(requiredVersion, version)) {
/******/ 				warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
/******/ 			}
/******/ 			return get(scope[key][version]);
/******/ 		});
/******/ 		var loadStrictSingletonVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
/******/ 			if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
/******/ 			var version = findSingletonVersionKey(scope, key, eager);
/******/ 			if (!satisfy(requiredVersion, version)) {
/******/ 				fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
/******/ 			}
/******/ 			return get(scope[key][version]);
/******/ 		});
/******/ 		var installedModules = {};
/******/ 		var moduleToHandlerMapping = {
/******/ 			12549: function() { return loadSingletonVersion("default", "react", true, [4,17,0,2], function() { return function() { return __webpack_require__(17866); }; }); },
/******/ 			23552: function() { return loadSingletonVersion("default", "@material-ui/core", true, [4,4,12,4], function() { return function() { return __webpack_require__(98227); }; }); },
/******/ 			51971: function() { return loadSingletonVersion("default", "react-dom", true, [4,17,0,2], function() { return function() { return __webpack_require__(13499); }; }); },
/******/ 			59217: function() { return loadSingletonVersion("default", "mobx", true, [1,6,1,0], function() { return function() { return __webpack_require__(48235); }; }); },
/******/ 			59377: function() { return loadSingletonVersion("default", "react-router-dom", true, [1,5,2,0], function() { return function() { return __webpack_require__(57847); }; }); },
/******/ 			63495: function() { return loadSingletonVersion("default", "@sarex-team/srx-pdf-runtime", true, [4,2,0,1], function() { return function() { return __webpack_require__(73370); }; }); },
/******/ 			64806: function() { return loadSingletonVersion("default", "mobx", true, [1,6,0,0], function() { return function() { return __webpack_require__(48235); }; }); },
/******/ 			80739: function() { return loadSingletonVersion("default", "@sarex-team/translator", true, [1,1,1,0], function() { return function() { return __webpack_require__(95562); }; }); },
/******/ 			97798: function() { return loadSingletonVersion("default", "@sarex-team/translator", true, [4,1,1,0], function() { return function() { return __webpack_require__(95562); }; }); },
/******/ 			70040: function() { return loadSingletonVersion("default", "@sarex-team/sdk-js", true, [4,0,3,72], function() { return function() { return __webpack_require__(25472); }; }); },
/******/ 			53350: function() { return loadSingletonVersion("default", "mobx", true, [4,6,9,0], function() { return function() { return __webpack_require__(48235); }; }); },
/******/ 			60706: function() { return loadSingletonVersion("default", "mobx-react-lite", true, [4,3,4,3], function() { return function() { return __webpack_require__(3707); }; }); },
/******/ 			63446: function() { return loadSingletonVersion("default", "@sarex-team/srx-ui-kit", false, [2,0,8,10], function() { return __webpack_require__.e(493).then(function() { return function() { return __webpack_require__(94493); }; }); }); },
/******/ 			63971: function() { return loadSingletonVersion("default", "L2DV", true, [1,1,9,0], function() { return function() { return __webpack_require__(32939); }; }); },
/******/ 			64919: function() { return loadSingletonVersion("default", "@sarex-team/ui-kit", true, [1,2,0,31], function() { return function() { return __webpack_require__(42689); }; }); }
/******/ 		};
/******/ 		var initialConsumes = [12549,23552,51971,59217,59377,63495,64806,80739,97798];
/******/ 		initialConsumes.forEach(function(id) {
/******/ 			__webpack_require__.m[id] = function(module) {
/******/ 				// Handle case when module is used sync
/******/ 				installedModules[id] = 0;
/******/ 				delete __webpack_require__.c[id];
/******/ 				var factory = moduleToHandlerMapping[id]();
/******/ 				if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
/******/ 				module.exports = factory();
/******/ 			}
/******/ 		});
/******/ 		var chunkMapping = {
/******/ 			"40": [
/******/ 				70040
/******/ 			],
/******/ 			"57": [
/******/ 				12549,
/******/ 				23552,
/******/ 				51971,
/******/ 				59217,
/******/ 				59377,
/******/ 				63495,
/******/ 				64806,
/******/ 				80739,
/******/ 				97798
/******/ 			],
/******/ 			"663": [
/******/ 				53350,
/******/ 				60706,
/******/ 				63446
/******/ 			],
/******/ 			"954": [
/******/ 				63971,
/******/ 				64919
/******/ 			]
/******/ 		};
/******/ 		var startedInstallModules = {};
/******/ 		__webpack_require__.f.consumes = function(chunkId, promises) {
/******/ 			if(__webpack_require__.o(chunkMapping, chunkId)) {
/******/ 				chunkMapping[chunkId].forEach(function(id) {
/******/ 					if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
/******/ 					if(!startedInstallModules[id]) {
/******/ 					var onFactory = function(factory) {
/******/ 						installedModules[id] = 0;
/******/ 						__webpack_require__.m[id] = function(module) {
/******/ 							delete __webpack_require__.c[id];
/******/ 							module.exports = factory();
/******/ 						}
/******/ 					};
/******/ 					startedInstallModules[id] = true;
/******/ 					var onError = function(error) {
/******/ 						delete installedModules[id];
/******/ 						__webpack_require__.m[id] = function(module) {
/******/ 							delete __webpack_require__.c[id];
/******/ 							throw error;
/******/ 						}
/******/ 					};
/******/ 					try {
/******/ 						var promise = moduleToHandlerMapping[id]();
/******/ 						if(promise.then) {
/******/ 							promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
/******/ 						} else onFactory(promise);
/******/ 					} catch(e) { onError(e); }
/******/ 					}
/******/ 				});
/******/ 			}
/******/ 		}
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		__webpack_require__.b = (typeof document !== 'undefined' && document.baseURI) || self.location.href;
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			57: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = function(chunkId, promises) {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(40 != chunkId) {
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise(function(resolve, reject) { installedChunkData = installedChunks[chunkId] = [resolve, reject]; });
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = function(event) {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						} else installedChunks[chunkId] = 0;
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	!function() {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// module cache are used so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [276], function() { return __webpack_require__(74178); })
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;